<template>
  <div class="all-users-container">
    <PageHeader 
      pageName="Dashboard Chatbot"
      pageTitle="Tableau de bord Chatbot"
      pageSubtitle="Vue d'ensemble des performances et statistiques de vos chatbots."
    />

    <div class="users-stats">

      <div class="stats-card">
        <div class="circle-icon chatbots">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
            <rect x="3" y="11" width="18" height="10" rx="2"></rect>
            <circle cx="12" cy="5" r="2"></circle>
            <path d="M12 7v4"></path>
            <line x1="8" y1="16" x2="8.01" y2="16"></line>
            <line x1="16" y1="16" x2="16.01" y2="16"></line>
          </svg>
        </div>
        <div class="stats-info" id="chatbot_you_nameit">
          <div class="stats-label"> </div>
          <div class="stats-value">
            
              <span class="number">{{ chatbotInfo ? chatbotInfo.bot_name : 'Chatbot' }}</span>
              
             
          </div>
        </div>
        <button class="refresh-stats"  >
          <router-link 
              :to="`/dashboard/chatbots/${chatbotId}/settings`" 
              class="chatbot-name-link"
            >
          <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                class="settings-icon"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
            </router-link>
        </button>
      </div>
      
      <div class="stats-card">
        <div class="circle-icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <div class="stats-info">
          <div class="stats-label">Utilisateurs</div>
          <div class="stats-value">
            <span class="number">{{ formatNumber(totalUsers) }}</span>
          </div>
        </div>
        <button class="refresh-stats" @click="refreshGlobalStats" title="Rafraîchir les statistiques">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M23 4v6h-6"></path>
            <path d="M1 20v-6h6"></path>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path>
            <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path>
          </svg>
        </button>
      </div>
      
     
      <div class="stats-card">
        <div class="circle-icon discussions">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
        <div class="stats-info">
          <div class="stats-label">Interactions</div>
          <div class="stats-value">
            <span class="number">{{ formatNumber(totalDiscussions) }}</span>
          </div>
        </div>
        <button class="refresh-stats" @click="refreshGlobalStats" title="Rafraîchir les statistiques">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M23 4v6h-6"></path>
            <path d="M1 20v-6h6"></path>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path>
            <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path>
          </svg>
        </button>
      </div>

     

      
    </div>

    <!-- Sélecteur de vue -->
    <div class="view-selector">
      <button 
        class="view-option" 
        :class="{ active: selectedView === 'dau' }"
        @click="selectedView = 'dau'"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        Utilisateurs Actifs
      </button>
      <button 
        class="view-option" 
        :class="{ active: selectedView === 'growth' }"
        @click="selectedView = 'growth'"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M23 6l-9.5 9.5-5-5L1 18"></path>
          <path d="M17 6h6v6"></path>
        </svg>
        Croissance
      </button>
      <button 
        class="view-option" 
        :class="{ active: selectedView === 'average' }"
        @click="selectedView = 'average'"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 20V10"></path>
          <path d="M18 20V4"></path>
          <path d="M6 20v-4"></path>
        </svg>
        Interactions Moyennes
      </button>

      <router-link :to="`/dashboard/chatbots/${chatbotId}/playground`" class="playground-btn">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
        Playground
      </router-link>

      <router-link :to="`/dashboard/chatbots/${chatbotId}/jarvis-knowledge`" class="jarvis-btn">
        <svg class="brain-icon" width="20" height="20" viewBox="0 0 300 300" fill="currentColor">
          <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)">
            <path d="M1150 2939 c-103 -20 -236 -118 -270 -198 -9 -23 -17 -30 -29 -25 -9 3 -46 9 -82 11 -152 12 -302 -74 -373 -215 -35 -70 -52 -167 -39 -231 l10 -51 -41 -19 c-188 -84 -280 -308 -207 -501 l20 -51 -39 -40 c-63 -65 -84 -120 -88 -226 -3 -66 1 -106 12 -140 23 -70 83 -143 148 -181 l56 -33 -24 -42 c-51 -92 -49 -236 3 -344 49 -99 171 -194 269 -209 41 -6 41 -6 47 -55 8 -65 60 -161 111 -206 97 -84 236 -114 351 -75 59 20 60 20 86 1 79 -56 219 -69 320 -30 71 27 141 88 179 155 l30 51 0 198 0 197 90 0 89 0 24 -35 24 -35 -23 -47 c-30 -58 -30 -98 -1 -154 62 -116 219 -121 295 -9 33 49 28 142 -11 193 -32 42 -102 72 -150 64 -30 -5 -35 -2 -53 31 -44 83 -43 82 -170 82 l-114 0 0 108 0 107 287 -2 288 -2 72 -83 73 -83 0 -77 0 -77 -42 -23 c-120 -66 -115 -244 8 -303 52 -25 132 -17 177 18 98 75 86 231 -22 286 l-37 19 4 94 4 94 -92 110 c-51 60 -98 112 -104 116 -6 4 -147 8 -313 8 l-303 0 0 85 0 85 308 0 307 -1 124 -144 125 -145 102 0 c99 0 102 -1 108 -24 8 -33 68 -83 116 -96 72 -19 152 17 187 83 22 44 21 127 -4 169 -30 52 -77 78 -140 78 -30 0 -67 -7 -83 -15 -30 -16 -80 -74 -80 -93 0 -8 -27 -12 -82 -12 l-83 0 -97 113 c-53 61 -110 127 -127 145 l-30 32 -325 0 -326 0 0 160 0 160 326 0 326 0 35 38 c19 20 76 85 126 144 l92 108 81 0 c78 0 82 -1 88 -24 8 -33 68 -83 116 -97 54 -16 113 2 161 50 115 116 -3 323 -161 281 -48 -13 -108 -63 -116 -96 -6 -23 -9 -24 -105 -24 -114 0 -89 17 -257 -177 l-97 -113 -307 0 -308 0 0 85 0 85 303 0 c166 0 307 4 313 8 6 4 53 56 103 116 l92 109 -2 94 -2 95 39 22 c131 73 101 268 -48 307 -42 12 -53 11 -94 -7 -136 -56 -151 -232 -26 -302 l42 -23 0 -79 0 -78 -72 -86 -73 -85 -287 -1 -288 0 0 110 0 109 118 3 117 3 34 53 c34 52 34 52 86 52 60 0 106 25 143 80 33 49 28 142 -11 193 -34 44 -101 72 -157 64 -117 -15 -190 -173 -120 -259 17 -22 17 -24 -4 -60 l-21 -38 -92 0 -93 0 0 188 0 187 -29 50 c-56 99 -162 173 -276 194 -66 12 -82 12 -145 0z"/>
          </g>
        </svg>
        Jarvis IA
      </router-link>
    </div>

    <!-- Section DAU -->
    <div v-if="chatbotStats?.dau && selectedView === 'dau'" class="dau-overview">
      <div class="dau-header">
        <h2>Utilisateurs Actifs Quotidiens (DAU)</h2>
      </div>

      <div class="dau-metrics-grid">
        <div v-for="(day, index) in chatbotStats.dau" :key="index" class="dau-stats-card">
          <div class="stats-card-date">{{ formatDauDate(day.date) }}</div>
          <div class="stats-card-content">
            <div class="stats-main-metric">
              <div class="circle-icon users">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div class="stats-info">
                <div class="stats-label">Utilisateurs Actifs</div>
                <div class="stats-value">
                  <span class="number-dau">{{ day.totalActiveUsers }}</span>
                </div>
              </div>
            </div>

            <div class="stats-secondary-metrics">
              <div class="secondary-metric">
                <div class="metric-label">Utilisateurs Récurrents</div>
                <div class="metric-value">{{ day.activeUsersExcludingNewRegistrations }}</div>
              </div>
              <div class="secondary-metric">
                <div class="metric-label">Nouveaux Utilisateurs</div>
                <div class="metric-value highlight">
                  {{ day.totalActiveUsers - day.activeUsersExcludingNewRegistrations }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Croissance -->
    <div v-if="selectedView === 'growth' && chatbotStats" class="growth-chart-section">
      <div class="chart-header">
        <h3>Croissance des utilisateurs</h3>
        <div class="period-selector">
          <label for="period-select">Période :</label>
          <select 
            id="period-select" 
            v-model="selectedPeriod"
            class="period-select"
          >
            <option 
              v-for="option in periodOptions" 
              :key="option.value" 
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <UserGrowthChart :stats="chatbotStats" />
    </div>

    <div v-if="selectedView === 'average' && chatbotStats?.average_discussion" class="average-chart-section">
      <div class="chart-header">
        <h3>Moyenne des Interactions par Mois</h3>
        <div class="period-selector">
          <label for="period-select">Période :</label>
          <select 
            id="period-select" 
            v-model="selectedPeriod"
            class="period-select"
          >
            <option 
              v-for="option in periodOptions" 
              :key="option.value" 
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="average-stats-grid">
        <div v-for="(stat, index) in chatbotStats.average_discussion" :key="index" class="average-stat-card">
          <div class="month-label">
            {{ formatMonthYear(stat.year, stat.month) }}
          </div>
          <div class="average-value">
            {{ Math.round(stat.averageInteractions * 100) / 100 }}
            <span class="average-unit">interactions/utilisateur</span>
          </div>
          <div class="trend-indicator" :class="getAverageTrend(index, chatbotStats.average_discussion)">
            {{ calculateAverageTrend(index, chatbotStats.average_discussion) }}
          </div>
        </div>
      </div>
    </div>
  
    <!-- Bloc Condition (replié par défaut) -->
    <div class="condition-block" :class="{ 'expanded': isConditionBlockOpen }">
      <!-- En-tête du bloc (toujours visible) -->
      <div class="condition-header" @click="toggleConditionBlock">
        <div class="condition-title">
          <span>Conditions</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </div>
        
        <!-- Résumé des conditions (visible quand replié) -->
        <div v-if="!isConditionBlockOpen && hasConditions" class="condition-summary">
          {{ getConditionSummary() }}
        </div>
        
        <!-- Chevron pour indiquer l'état ouvert/fermé -->
        <div class="condition-toggle">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" :class="{ 'rotated': isConditionBlockOpen }">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>
      
      <!-- Contenu du bloc (visible seulement quand déplié) -->
      <div class="condition-content" v-if="isConditionBlockOpen">
        <!-- Contenu existant -->

        <!-- Bouton de débogage temporaire pour charger les variables -->
    
        <div v-for="(cond, idx) in conditions" :key="idx" class="condition-row">
          <div class="condition-label">Attribut</div>
          
          <div class="variable-dropdown-container">
            <!-- Affichage du tag quand une variable est sélectionnée -->
            <div v-if="cond.attribute" class="variable-tag">
              <span @click="cond.showDropdown = true">&#123;&#123;{{ cond.attribute }}&#125;&#125;</span>
              <button class="remove-tag-btn" @click="clearVariable(cond)">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
             
            <!-- Input de recherche -->
            <input 
              v-if="!cond.attribute || cond.showDropdown"
              v-model="cond.searchTerm" 
              class="variable-search" 
              placeholder="attribute"
              @focus="handleFocusSearch(cond)"
              @input="handleSearchInput(cond)"
              @keydown.enter.prevent="validateCustomVariable(cond)"
              @click.stop
            />
            
            <!-- Liste déroulante d'autocomplétion -->
            <div v-if="cond.showDropdown" class="dropdown-menu" @click.stop>
              <div 
                v-for="variable in cond.filteredVariables" 
                :key="variable.id" 
                @click="selectVariable(cond, variable.slug)" 
                class="dropdown-item"
                :class="{ 'highlight': cond.searchTerm && variable.slug.toLowerCase().includes(cond.searchTerm.toLowerCase()) }"
              >
                {{ variable.slug }}
              </div>
              <!-- Afficher un message si aucune variable ne correspond à la recherche -->
              <div v-if="cond.filteredVariables.length === 0 && cond.searchTerm" class="dropdown-custom-item">
                <span>Appuyez sur Entrée pour ajouter "{{ cond.searchTerm }}"</span>
              </div>
            </div>
          </div>
          
          <!-- Remplacer le label statique par un sélecteur -->
          <select v-model="cond.comparison" class="condition-comparison">
            <option value="equals">égale à</option>
            <option value="not_equals">est différent de</option>
          </select>
          
          <!-- Input de valeur avec autocomplétion -->
          <div class="value-dropdown-container">
            <!-- Affichage du tag quand une valeur est sélectionnée -->
            <div v-if="cond.value && !cond.valueShowDropdown" class="value-tag">
              <span @click="handleValueFocus(cond)">{{ cond.value }}</span>
              <button class="remove-tag-btn" @click="clearValue(cond)">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            
            <!-- Input de recherche pour les valeurs -->
            <input 
              v-if="!cond.value || cond.valueShowDropdown"
              v-model="cond.valueSearchTerm" 
              class="variable-search" 
              placeholder="valeur"
              @focus="handleValueFocus(cond)"
              @input="handleValueSearchInput(cond)"
              @keydown.enter.prevent="validateCustomValue(cond)"
              @click.stop
            />
            
            <!-- Liste déroulante d'autocomplétion pour les valeurs -->
            <div v-if="cond.valueShowDropdown" class="dropdown-menu" @click.stop>
              <!-- Loading indicator -->
              <div v-if="cond.valueLoading" class="dropdown-loading">
                <svg class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 6v2"></path>
                </svg>
                Chargement des valeurs...
              </div>
              
              <!-- No values message -->
              <div v-else-if="cond.possibleValues.length === 0 && !cond.valueSearchTerm" class="dropdown-empty">
                Aucune valeur disponible
              </div>
              
              <!-- Values list -->
              <div 
                v-else
                v-for="valueObj in cond.filteredValues" 
                :key="valueObj._id" 
                @click="selectValue(cond, valueObj._id)" 
                class="dropdown-item"
                :class="{ 'highlight': cond.valueSearchTerm && String(valueObj._id).includes(cond.valueSearchTerm) }"
              >
                {{ valueObj._id || 'null' }} ({{ valueObj.count }})
              </div>
              
              <!-- Afficher un message si aucune valeur ne correspond à la recherche -->
              <div v-if="cond.filteredValues.length === 0 && cond.valueSearchTerm" class="dropdown-custom-item">
                <span>Appuyez sur Entrée pour ajouter "{{ cond.valueSearchTerm }}"</span>
              </div>
            </div>
          </div>
          
          <!-- Toujours afficher l'élément, mais le masquer quand non nécessaire -->
          <select v-model="cond.operator" class="condition-operator" :class="{ 'invisible': idx === conditions.length - 1 }">
            <option value="and">et</option>
            <option value="or">ou</option>
          </select>
          
          <button v-if="conditions.length > 1" @click="removeCondition(idx)" class="remove-condition-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ff4d4d" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </button>
          <div v-else class="remove-condition-placeholder"></div>
        </div>
        
        <button @click="addCondition" class="add-condition-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>

        <!-- Bouton de recherche avec les conditions -->
        <div class="search-action-container">
          <button @click="sendConditionsToAPI" class="search-conditions-btn" :disabled="!hasValidConditions">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            Rechercher
          </button>
        </div>
        
        <!-- Console de résultat de requête -->
        <div v-if="showQueryConsole" class="query-console-container">
          <div class="query-console-header">
            <span>Résultat de la requête</span>
            <button class="console-close-btn" @click="showQueryConsole = false">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="query-console-content">
            <pre v-html="formatJsonWithHighlighting(queryResult)"></pre>
          </div>
          <div class="query-console-actions">
            <button @click="fetchMatchingUsers" class="view-users-btn" v-if="!showUsersList">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              Voir les utilisateurs
            </button>
          </div>
        </div>
        
        <!-- Liste des utilisateurs correspondants -->
        <div v-if="showUsersList" class="matching-users-container">
          <div class="matching-users-header">
            <span>Utilisateurs correspondants ({{ matchingUsers.length }})</span>
                          <div class="matching-users-actions">
                <div class="broadcast-select-wrapper" v-if="matchingUsers.length > 0">
                  <select 
                    class="broadcast-select" 
                    v-model="selectedBroadcastId"
                    @change="handleBroadcastSelection"
                  >
                    <option value="" disabled>Choisir un modèle</option>
                    <option 
                      v-for="model in broadcastMessages" 
                      :key="model.id" 
                      :value="model.id"
                    >
                      {{ model.title }}
                    </option>
                  </select>
                  <button 
                    class="broadcast-action-btn" 
                    @click="sendBroadcastToUsers" 
                    :disabled="!selectedBroadcast || broadcastSending"
                    :class="{'disabled-btn': !selectedBroadcast}"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                    Envoyer un broadcast
                  </button>
                </div>
                <button class="console-close-btn" @click="showUsersList = false">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
          </div>
          <div class="matching-users-content">
            <div v-if="matchingUsers.length === 0" class="no-users">
              Aucun utilisateur trouvé
            </div>
            <div v-else>
              <div class="broadcast-menu" v-if="showBroadcastMenu">
                <div class="broadcast-menu-header">
                  <h4>Messages de broadcast</h4>
                  <button class="broadcast-menu-close" @click="showBroadcastMenu = false">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
                <div class="broadcast-menu-content">
                  <div v-if="broadcastLoading" class="broadcast-loading">
                    <div class="loader-small"></div>
                    <span>Chargement des broadcasts...</span>
                  </div>
                  <div v-else-if="broadcastMessages.length === 0" class="no-broadcast">
                    Aucun message broadcast disponible
                  </div>
                  <div v-else class="broadcast-list">
                    <div 
                      v-for="(broadcast, index) in broadcastMessages" 
                      :key="index"
                      class="broadcast-item"
                      @click="selectBroadcast(broadcast)"
                    >
                      {{ broadcast.title }}
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="broadcast-details" v-if="selectedBroadcast">
                <div class="broadcast-details-header">
                  <h4>{{ selectedBroadcast.title }}</h4>
                  <button class="broadcast-details-close" @click="selectedBroadcast = null">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
                <div class="broadcast-details-content">
                  <div v-if="broadcastVariables && Object.keys(broadcastVariables).length > 0" class="broadcast-variables">
                    <h5>Variables</h5>
                    <div 
                      v-for="(value, key) in broadcastVariables" 
                      :key="key" 
                      class="broadcast-variable-item"
                    >
                      <label :for="`var-${key}`">Variable {{key}}</label>
                      <input 
                        :id="`var-${key}`" 
                        type="text" 
                        v-model="broadcastVariables[key]" 
                        placeholder="Valeur"
                      />
                    </div>
                  </div>
                  <div class="broadcast-preview">
                    <h5>Aperçu</h5>
                    <div class="broadcast-preview-content">
                      <p>{{ getFormattedBroadcastMessage() }}</p>
                    </div>
                  </div>
                  <div class="broadcast-actions">
                    <button 
                      class="broadcast-send-btn" 
                      @click="sendBroadcastToUsers" 
                      :disabled="broadcastSending"
                    >
                      <span v-if="!broadcastSending">Envoyer à {{ matchingUsers.length }} utilisateurs</span>
                      <span v-else>
                        <div class="loader-small"></div>
                        Envoi en cours ({{ broadcastProgress }}/{{ matchingUsers.length }})
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              
              <div class="user-tags" v-if="!showBroadcastMenu && !selectedBroadcast">
                <div 
                  v-for="(user, index) in matchingUsers" 
                  :key="index" 
                  class="user-tag"
                  @click="openChat(user)"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                  </svg>
                  {{ formatPhoneDisplay(getUserPhone(user)) }}
                </div>
              </div>
              
              <div v-if="broadcastSent" class="broadcast-sent-success">
                <div class="broadcast-report-header">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#25D366" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <p class="broadcast-status-text">
                    Broadcast envoyé: 
                    <strong class="success-count">{{ successCount || 0 }} réussis</strong>, 
                    <strong class="failed-count">{{ failedCount || 0 }} échoués</strong> 
                    sur <strong class="total-count">{{ matchingUsers.length || 0 }} utilisateurs</strong>
                  </p>
                </div>
                
                <div v-if="showBroadcastReport" class="broadcast-report-container">
                  <div class="broadcast-report-summary">
                    <div class="report-stat">
                      <span class="report-label">Taux de succès:</span>
                      <span class="report-value">{{ Math.round((successCount / (matchingUsers.length || 1)) * 100) || 0 }}%</span>
                    </div>
                    <div class="report-stat">
                      <span class="report-label">Modèle utilisé:</span>
                      <span class="report-value">{{ selectedBroadcastId ? broadcastMessages.find(b => Number(b.id) === Number(selectedBroadcastId))?.title || 'Non spécifié' : 'Non spécifié' }}</span>
                    </div>
                    <div class="report-stat">
                      <span class="report-label">Heure d'envoi:</span>
                      <span class="report-value">{{ new Date().toLocaleTimeString() }}</span>
                    </div>
                  </div>
                  
                  <div class="broadcast-report-summary">
                    <h3 style="width: 100%; text-align: center; margin-bottom: 16px; color: #333; font-size: 16px;">
                      Réponses brutes du serveur
                    </h3>
                  </div>
                  
                  <div v-if="rawResponses.length === 0" class="no-responses">
                    Aucune réponse à afficher
                  </div>
                  <div v-else class="raw-responses-container">
                    <div v-for="(response, index) in rawResponses" :key="index" class="raw-response-item">
                      <div class="response-header">
                        <span class="response-title">Réponse #{{ index + 1 }} - {{ response.phone }}</span>
                        <span class="response-status" :class="{'status-success': response.isSuccess}">
                          {{ response.isSuccess ? 'Réussi' : 'Échoué' }}
                        </span>
                      </div>
                      <pre class="response-body">{{ JSON.stringify(response.data, null, 2) }}</pre>
                    </div>
                  </div>
                  
                  <div class="broadcast-report-table">
                    <table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Téléphone</th>
                          <th>Statut</th>
                          <th>Message ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="entry in broadcastReport" :key="entry.index" :class="{'report-success': entry.status === 'Succès', 'report-error': entry.status === 'Erreur', 'report-fail': entry.status === 'Échec'}">
                          <td>{{ entry.index }}</td>
                          <td>{{ entry.phone }}</td>
                          <td>{{ entry.status }}</td>
                          <td>
                            <span v-if="entry.status === 'Succès'" class="message-id">{{ entry.messageId }}</span>
                            <span v-else class="error-details">{{ entry.errorDetails }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                <div class="broadcast-report-actions">
                  <button class="broadcast-dismiss-btn" @click="broadcastSent = false; showBroadcastReport = false;">
                    Fermer
                  </button>
                  <button class="broadcast-toggle-report-btn" @click="toggleBroadcastReport">
                    {{ showBroadcastReport ? 'Masquer le rapport' : 'Afficher les réponses du serveur' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin Bloc Condition -->

    <div class="table-controls">
      <div class="search-container">
        <input 
          type="text" 
          v-model="searchQuery" 
          placeholder="Rechercher un utilisateur..." 
          @input="debounceSearch"
        />
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <div class="table-actions" style="display: none;">
        <button class="filter-button" @click="toggleFilterMenu">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
          </svg>
          Filtres
          <span v-if="activeFilters.length" class="filter-count">{{ activeFilters.length }}</span>
        </button>
        <div v-if="showFilterMenu" class="filter-menu">
          <div class="filter-section">
            <h4>Statut</h4>
            <label class="filter-option">
              <input type="checkbox" v-model="filters.active" @change="applyFilters">
              Utilisateurs actifs
            </label>
            <label class="filter-option">
              <input type="checkbox" v-model="filters.inactive" @change="applyFilters">
              Utilisateurs inactifs
            </label>
          </div>
          <div class="filter-section">
            <h4>Interactions</h4>
            <label class="filter-option">
              <input type="checkbox" v-model="filters.hasInteractions" @change="applyFilters">
              Avec interactions
            </label>
            <label class="filter-option">
              <input type="checkbox" v-model="filters.noInteractions" @change="applyFilters">
              Sans interactions
            </label>
          </div>
          <div class="filter-actions">
            <button class="clear-filters" @click="clearFilters">Effacer les filtres</button>
          </div>
        </div>
      </div>
    </div>

    <div class="users-list-container" ref="scrollContainer">
      <div v-if="loading && users.length === 0" class="loading-container">
        <div class="loader"></div>
        <p>Chargement des utilisateurs...</p>
      </div>

      <div v-else-if="users.length === 0 && !loading" class="empty-state">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <p>Aucun utilisateur trouvé</p>
        <button class="action-button" @click="refreshUsers">
          Réessayer
        </button>
      </div>

      <div v-else class="users-table">
        <table>
          <thead>
            <tr>
              <th class="user-cell">Utilisateur</th>
              <th class="user-cell" @click="toggleChatbotSort">
                Chatbot
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" :class="{ 'sort-active': chatbotSort !== 'none' }">
                  <path v-if="chatbotSort === 'none'" d="M6 9l6 6 6-6"/>
                  <path v-else-if="chatbotSort === 'asc'" d="M12 19l-6-6h12l-6 6z"/>
                  <path v-else d="M12 5l6 6H6l6-6z"/>
                </svg>
              </th>
              <th class="user-cell" @click="toggleInteractionsSort">
                Interactions
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" :class="{ 'sort-active': interactionsSort !== 'none' }">
                  <path v-if="interactionsSort === 'none'" d="M6 9l6 6 6-6"/>
                  <path v-else-if="interactionsSort === 'asc'" d="M12 19l-6-6h12l-6 6z"/>
                  <path v-else d="M12 5l6 6H6l6-6z"/>
                </svg>
              </th>
              <th class="activity-header" @click="toggleActivitySort">
                Dernière activité
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" :class="{ 'sort-active': activitySort !== 'none' }">
                  <path v-if="activitySort === 'none'" d="M6 9l6 6 6-6"/>
                  <path v-else-if="activitySort === 'asc'" d="M12 19l-6-6h12l-6 6z"/>
                  <path v-else d="M12 5l6 6H6l6-6z"/>
                </svg>
              </th>
              <th>Actions</th>
              <th class="actions-cell"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="user.id || index">
              <td class="user-cell">
                
                 <div class="user-info">
                  <div class="user-avatar">
                    <img :src="getAvatarUrl(user.name)" alt="User avatar">
                    <span class="status-indicator" :class="{ active: user.isActive }"></span>
                    
                  </div>
                  <div class="user-details">
                    <div class="user-name">{{ user.name }}</div>
                    <div class="user-email">{{ user.email || formatPhoneNumber(user.phone) }}</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="access-tags">
                  <span class="access-tag data" @click="redirectToChatbotPage(user.idbot)">
                    {{ user.bot }}
                  </span>
                </div>
              </td>
              <td class="interactions-cell">
                <div class="interactions-count">
                  {{ formatNumber(user.discussions) }}
                </div>
              </td>
              <td>{{ formatTimeAgo(user.lastActivity) }}</td>
              <td class="action-icons">
                <div class="action-icon-container" title="Diffuser un message">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                </div>
                <router-link 
                  :to="`/dashboard/chat/${user.idbot}/${user.phone}`" 
                  class="action-icon-container" 
                  title="Ouvrir la conversation"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </router-link>
                <div class="action-icon-container" title="Ouvrir WhatsApp" @click="openWhatsApp(user.phone)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                  </svg>
                </div>
              </td>
              <td class="actions-cell">
                <div class="actions-dropdown">
                  <button class="table-action-button" @click="toggleActionMenu(index)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="1"></circle>
                      <circle cx="19" cy="12" r="1"></circle>
                      <circle cx="5" cy="12" r="1"></circle>
                    </svg>
                  </button>
                  <div v-if="activeActionMenu === index" class="action-menu">
                    <router-link 
                      :to="`/dashboard/chat/${user.idbot}/${user.phone}`" 
                      class="action-item"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      Voir détails
                    </router-link>
                     
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
         
        <div class="pagination-container">
          <div class="pagination-info">
            <div class="users-per-page">
              <select v-model="selectedLimit" @change="handleLimitChange">
                <option value="10">10</option>
                <option value="20" selected>20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="all">Tous</option>
              </select>
            </div>
          </div>
          <div class="load-more-container">
            <button 
              v-if="hasMoreUsers && !loading" 
              class="load-more-button" 
              @click="loadMoreUsers"
            >
              Charger plus d'utilisateurs
            </button>
            
            <div v-if="loading" class="loading-more">
              <div class="loader"></div>
              <p>Chargement de plus d'utilisateurs...</p>
            </div>

            <div v-if="!hasMoreUsers && users.length > 0 && !loading" class="end-message">
              Fin de la liste des utilisateurs
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Section Moyenne des Interactions -->
   
  
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick, watch, computed } from 'vue';
import { apiBaseUrl } from '@/config';
import axios from 'axios';
import PageHeader from '@/components/PageHeader.vue';
import UserGrowthChart from '@/components/UserGrowthChart.vue';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: 'AllUsersPage',
  components: {
    PageHeader,
    UserGrowthChart
  },
  setup() {
    const users = ref([]);
    const originalUsers = ref([]);
    const loading = ref(false);
    const page = ref(1);
    const limit = ref("20");
    const selectedLimit = ref("20");
    const hasMoreUsers = ref(true);
    const scrollContainer = ref(null);
    const searchQuery = ref('');
    const searchTimeout = ref(null);
    const chatbotSort = ref('none');
    const activeActionMenu = ref(null);
    const activitySort = ref('none');
    const interactionsSort = ref('none');
    const showFilterMenu = ref(false);
    const filters = ref({
      active: false,
      inactive: false,
      hasInteractions: false,
      noInteractions: false
    });

    const router = useRouter();
    const route = useRoute();
    const chatbotId = computed(() => route.params.id);

    const user = ref(null);
    const chatbotInfo = ref(null);
    const chatbotStats = ref(null);
    const selectedPeriod = ref(6); // Par défaut 6 mois
    const periodOptions = [
      { value: 3, label: '3 mois' },
      { value: 6, label: '6 mois' },
      { value: 8, label: '8 mois' },

      { value: 10, label: '10 mois' },
      { value: 12, label: '12 mois' },
      { value: 24, label: '24 mois' }
    ];

    const selectedView = ref('dau'); // Valeur par défaut: DAU

    // Ajouter un watcher pour déboguer limit
    watch(limit, (newValue) => {
      
    }, { immediate: true });
    
    // Statistiques globales de l'API
    const globalStats = ref({
      chatbotCount: 0,
      userCount: 0,
      discussionCount: 0
    });
    
    // Variables dérivées pour l'affichage
    const totalUsers = ref(0);
    const totalDiscussions = ref(0);
    const totalChatbots = ref(0);
    
    const statsLoading = ref(false);
    const statsError = ref(null);
    const statsLoaded = ref(false);

    // Computed property pour les filtres actifs
    const activeFilters = computed(() => {
      return Object.entries(filters.value)
        .filter(([_, value]) => value)
        .map(([key]) => key);
    });

    // Fonction pour basculer le menu de filtres
    const toggleFilterMenu = () => {
      showFilterMenu.value = !showFilterMenu.value;
    };

    // Fonction pour appliquer les filtres
    const applyFilters = () => {
      
      
      // Filtrer les utilisateurs selon les critères sélectionnés
      const filteredUsers = originalUsers.value.filter(user => {
        // Filtre par statut
        if (filters.value.active && !user.isActive) return false;
        if (filters.value.inactive && user.isActive) return false;
        
        // Filtre par interactions
        const hasInteractions = (user.discussions || 0) > 0;
        if (filters.value.hasInteractions && !hasInteractions) return false;
        if (filters.value.noInteractions && hasInteractions) return false;
        
        return true;
      });
      
      // Mettre à jour la liste des utilisateurs
      users.value = filteredUsers;
    };

    // Fonction pour effacer tous les filtres
    const clearFilters = () => {
      Object.keys(filters.value).forEach(key => {
        filters.value[key] = false;
      });
      users.value = [...originalUsers.value];
    };

    // Fermer les menus quand on clique ailleurs
    const handleGlobalClick = (event) => {
      if (!event.target.closest('.actions-dropdown')) {
        activeActionMenu.value = null;
      }
      if (!event.target.closest('.table-actions')) {
        showFilterMenu.value = false;
      }
    };

    // Ajouter l'écouteur de clic global
    onMounted(() => {
      document.addEventListener('click', handleGlobalClick);
    });

    // Nettoyer l'écouteur de clic
    onUnmounted(() => {
      document.removeEventListener('click', handleGlobalClick);
    });

    // Fonction pour charger les utilisateurs depuis l'API
    const loadUsers = async (reset = false) => {
      if (loading.value) return;
      
      loading.value = true;
      
      
      try {
        // Récupérer le token depuis le localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error('❌ Données utilisateur non trouvées');
          loading.value = false;
          return;
        }

        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error('❌ Token non trouvé');
          loading.value = false;
          return;
        }

        if (reset) {
          page.value = 1;
          users.value = [];
        }
        
        // Construire l'URL avec les paramètres de pagination et de recherche
        let url = `${apiBaseUrl}/get/strong/users`;
        let params = {
          page: page.value,
          limit: selectedLimit.value === 'all' ? 999999 : parseInt(selectedLimit.value),
          idbotget: chatbotId.value // Ajouter l'ID du chatbot comme paramètre
        };
        
        // Ajouter le paramètre de recherche uniquement si une recherche est en cours
        if (searchQuery.value && searchQuery.value.trim() !== '') {
          params.search = searchQuery.value.trim();
          
        }
        
        
        
        const response = await axios({
          method: 'get',
          url: url,
          params: params,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });
        
        const responseData = response.data;
        
        
        
        // Traitement du nouveau format de réponse (objet avec message, users et pagination)
        if (responseData && responseData.users && Array.isArray(responseData.users)) {
          const usersData = responseData.users;
          
          
          // Obtenir les informations de pagination
          const pagination = responseData.pagination || {};
          
          
          // Ne PAS recalculer les statistiques globales pour éviter d'écraser celles de l'API
          // On utilise les statistiques locales seulement si les globales n'ont pas été chargées
          if (reset && !statsLoaded.value) {
            
            let uniqueBots = new Set();
            let totalDisc = 0;
            
            usersData.forEach(user => {
              if (user.idbot) uniqueBots.add(user.idbot);
              if (user.total_discussions) totalDisc += user.total_discussions;
            });
            
            totalUsers.value = usersData.length;
            totalChatbots.value = uniqueBots.size;
            totalDiscussions.value = totalDisc;
          }
          
          // Mapper les données pour correspondre à notre structure
          const formattedUsers = usersData.map(user => {
            
            const formattedUser = {
              id: user.id_dialog,
              name: user.user_full_name || 'Sans nom',
              phone:  user.tel ,
              phonebot: user.telbot ,
              email: user.email || '',
              bot: user.bot_name || 'Non spécifié',
              idbot: user.idbot || null,
              iduser: user.iduser,
              discussions: user.total_discussions || 0,
              lastActivity: user.created_at || new Date().toISOString(),
              isActive: user.is_active || true,
              profileImage: user.user_image_profile || ''
            };
            return formattedUser;
          });
          
          
          
          // Mettre à jour la liste des utilisateurs
          if (reset) {
            users.value = formattedUsers;
            originalUsers.value = formattedUsers;
          } else {
            users.value = [...users.value, ...formattedUsers];
            originalUsers.value = [...originalUsers.value, ...formattedUsers];
          }
          
          // Incrémenter la page APRÈS un appel API réussi
          page.value++;
          
          
          // Vérifier s'il y a plus d'utilisateurs à charger
          // Si le serveur renvoie moins d'éléments que la limite, c'est qu'il n'y en a plus
          const hasMore = usersData.length >= parseInt(selectedLimit.value);
          hasMoreUsers.value = hasMore;
          
          
        } else {
          console.warn('⚠️ Format de réponse inattendu:', responseData);
          hasMoreUsers.value = false;
        }
        
      } catch (error) {
        console.error('❌ Erreur lors du chargement des utilisateurs:', error.response?.data || error.message || error);
        
        if (error.response) {
          console.error('❌ Statut de l\'erreur:', error.response.status);
          
          if (error.response.status === 401) {
            console.error('❌ Token invalide ou expiré');
          }
        }
        
        hasMoreUsers.value = false;
      } finally {
        loading.value = false;
        
      }
    };

    // Fonction pour charger les statistiques globales
    const loadGlobalStats = async () => {
      statsLoading.value = true;
      statsError.value = null;
      
      try {
        
        
        // Récupérer le token depuis le localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error('❌ Données utilisateur non trouvées');
          statsLoading.value = false;
          return;
        }

        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error('❌ Token non trouvé');
          statsLoading.value = false;
          return;
        }
        let url = `${apiBaseUrl}/get/stats`;
        
        const response = await axios({
          method: 'get',
          url: url,
          params: {
            idbotget: chatbotId.value // Ajouter l'ID du chatbot comme paramètre
          },
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });
        
        const statsData = response.data;
        
        
        if (statsData && statsData.stats) {
          // Stocker les statistiques globales dans une variable dédiée
          globalStats.value = {
            chatbotCount: statsData.stats.chatbotCount || 0,
            userCount: statsData.stats.userCount || 0,
            discussionCount: statsData.stats.discussionCount || 0
          };
          
          // Définir les valeurs d'affichage
          totalChatbots.value = globalStats.value.chatbotCount;
          totalUsers.value = globalStats.value.userCount;
          totalDiscussions.value = globalStats.value.discussionCount;
          
          // Marquer les statistiques comme chargées
          statsLoaded.value = true;
          
          
        }
      } catch (error) {
        console.error('❌ Erreur lors du chargement des statistiques:', error.response?.data || error.message || error);
        statsError.value = 'Impossible de charger les statistiques globales';
      } finally {
        statsLoading.value = false;
      }
    };

    // Fonction pour recharger uniquement les statistiques globales
    const refreshGlobalStats = async () => {
      try {
        
        await loadGlobalStats();
        
      } catch (error) {
        console.error('❌ Erreur lors du rafraîchissement des statistiques:', error);
      }
    };

    // Fonction pour charger plus d'utilisateurs (appelée par le bouton)
    const loadMoreUsers = () => {
      
      loadUsers(false);
    };

    // Fonction pour rechercher des utilisateurs
    const searchUsers = () => {
      
      // Réinitialiser les variables de pagination et recharger les utilisateurs
      page.value = 1;
      hasMoreUsers.value = true;
      loadUsers(true);
    };

    // Fonction pour débouncer la recherche
    const debounceSearch = () => {
      if (searchTimeout.value) {
        clearTimeout(searchTimeout.value);
      }
      
      searchTimeout.value = setTimeout(() => {
        if (searchQuery.value.trim() !== '') {
          
          searchUsers();
        } else {
          
          page.value = 1;
          loadUsers(true);
        }
      }, 500); // Attendre 500ms avant de lancer la recherche
    };

    // Fonction pour actualiser la liste des utilisateurs
    const refreshUsers = () => {
      loadUsers(true);
    };

    // Formater les numéros de téléphone en fonction du pays
    const formatPhoneNumber = (phone) => {
      if (!phone) return '';
      
      // Nettoyage du numéro (suppression des caractères non numériques)
      const cleanNumber = phone.replace(/\D/g, '');
      
      // Si le numéro est vide après nettoyage
      if (!cleanNumber) return phone;
      
      // Définition des formats par région
      const phoneFormats = {
        // Europe
        '33': { // France
          format: (num) => num.startsWith('0') ? 
            num.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5') : 
            `+33 ${num.substring(2).replace(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')}`,
          testLength: [10, 11, 12]
        },
        '44': { // Royaume-Uni
          format: (num) => `+44 ${num.substring(2).replace(/(\d{4})(\d{6})/, '$1 $2')}`,
          testLength: [12, 13]
        },
        '49': { // Allemagne
          format: (num) => `+49 ${num.substring(2).replace(/(\d{3})(\d{7})/, '$1 $2')}`,
          testLength: [12, 13]
        },
        '34': { // Espagne
          format: (num) => `+34 ${num.substring(2).replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')}`,
          testLength: [11, 12]
        },
        '39': { // Italie
          format: (num) => `+39 ${num.substring(2).replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')}`,
          testLength: [11, 12]
        },
        '351': { // Portugal
          format: (num) => `+351 ${num.substring(3).replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        },
        '32': { // Belgique
          format: (num) => `+32 ${num.substring(2).replace(/(\d{3})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [11, 12]
        },
        '31': { // Pays-Bas
          format: (num) => `+31 ${num.substring(2).replace(/(\d{2})(\d{8})/, '$1 $2')}`,
          testLength: [12, 13]
        },
        '41': { // Suisse
          format: (num) => `+41 ${num.substring(2).replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [11, 12]
        },
        '43': { // Autriche
          format: (num) => `+43 ${num.substring(2).replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')}`,
          testLength: [11, 12]
        },
        '46': { // Suède
          format: (num) => `+46 ${num.substring(2).replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [11, 12]
        },
        '47': { // Norvège
          format: (num) => `+47 ${num.substring(2).replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [10, 11]
        },
        '45': { // Danemark
          format: (num) => `+45 ${num.substring(2).replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [10, 11]
        },
        '358': { // Finlande
          format: (num) => `+358 ${num.substring(3).replace(/(\d{2})(\d{4})(\d{3})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        },
        
        // Amérique du Nord
        '1': { // États-Unis/Canada
          format: (num) => num.length === 10 ? 
            `(${num.substring(0, 3)}) ${num.substring(3, 6)}-${num.substring(6)}` :
            `+1 ${num.substring(1).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}`,
          testLength: [10, 11]
        },
        
        // Amérique Latine
        '52': { // Mexique
          format: (num) => `+52 ${num.substring(2).replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        },
        '55': { // Brésil
          format: (num) => `+55 ${num.substring(2).replace(/(\d{2})(\d{4,5})(\d{4})/, '$1 $2-$3')}`,
          testLength: [12, 13]
        },
        
        // Afrique
        '212': { // Maroc
          format: (num) => `+212 ${num.substring(3).replace(/(\d{3})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [12, 13]
        },
        '213': { // Algérie
          format: (num) => `+213 ${num.substring(3).replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [12, 13]
        },
        '216': { // Tunisie
          format: (num) => `+216 ${num.substring(3).replace(/(\d{2})(\d{3})(\d{3})/, '$1 $2 $3')}`,
          testLength: [11, 12]
        },
        '20': { // Égypte
          format: (num) => `+20 ${num.substring(2).replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        },
        '27': { // Afrique du Sud
          format: (num) => `+27 ${num.substring(2).replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3')}`,
          testLength: [11, 12]
        },
        '221': { // Sénégal
          format: (num) => `+221 ${num.substring(3).replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [12, 13]
        },
        '225': { // Côte d'Ivoire
          format: (num) => `+225 ${num.substring(3).replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [12, 13]
        },
        '237': { // Cameroun
          format: (num) => `+237 ${num.substring(3).replace(/(\d{3})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}`,
          testLength: [12, 13]
        },
        
        // Asie
        '86': { // Chine
          format: (num) => `+86 ${num.substring(2).replace(/(\d{3})(\d{8})/, '$1 $2')}`,
          testLength: [13, 14]
        },
        '91': { // Inde
          format: (num) => `+91 ${num.substring(2).replace(/(\d{5})(\d{5})/, '$1 $2')}`,
          testLength: [12, 13]
        },
        '81': { // Japon
          format: (num) => `+81 ${num.substring(2).replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        },
        '82': { // Corée du Sud
          format: (num) => `+82 ${num.substring(2).replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        },
        '65': { // Singapour
          format: (num) => `+65 ${num.substring(2).replace(/(\d{4})(\d{4})/, '$1 $2')}`,
          testLength: [10, 11]
        },
        
        // Océanie
        '61': { // Australie
          format: (num) => `+61 ${num.substring(2).replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3')}`,
          testLength: [12, 13]
        }
      };

      // Si le numéro commence par un 0 et a 10 chiffres, il s'agit probablement d'un numéro français
      if (cleanNumber.startsWith('0') && cleanNumber.length === 10) {
        return cleanNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
      }
      
      // Tenter de déterminer le code pays
      let countryCode = null;
      // Essayer d'abord avec 3 chiffres, puis 2, puis 1
      if (cleanNumber.length >= 3) {
        const code3 = cleanNumber.substring(0, 3);
        if (phoneFormats[code3]) {
          countryCode = code3;
        }
      }
      
      if (!countryCode && cleanNumber.length >= 2) {
        const code2 = cleanNumber.substring(0, 2);
        if (phoneFormats[code2]) {
          countryCode = code2;
        }
      }
      
      if (!countryCode && cleanNumber.length >= 1) {
        const code1 = cleanNumber.substring(0, 1);
        if (phoneFormats[code1]) {
          countryCode = code1;
        }
      }
      
      // Si on a identifié un code pays et que le format correspondant existe
      if (countryCode && phoneFormats[countryCode]) {
        const format = phoneFormats[countryCode];
        
        // Vérifier que la longueur du numéro correspond à ce qu'on attend
        if (format.testLength.includes(cleanNumber.length)) {
          return format.format(cleanNumber);
        }
      }
      
      // Format générique pour les pays non spécifiés
      if (cleanNumber.length > 7) {
        // Essayons de deviner le code pays (généralement 1-3 chiffres)
        let countryCodeGuess = ''; 
        let nationalNumber = '';
        
        if (cleanNumber.length >= 11) {
          countryCodeGuess = cleanNumber.substring(0, 3);
          nationalNumber = cleanNumber.substring(3);
        } else if (cleanNumber.length >= 10) {
          countryCodeGuess = cleanNumber.substring(0, 2);
          nationalNumber = cleanNumber.substring(2);
        } else {
          countryCodeGuess = cleanNumber.substring(0, 1);
          nationalNumber = cleanNumber.substring(1);
        }
        
        // Format générique international: +XX XXXXXXXX
        return `+${countryCodeGuess} ${nationalNumber.replace(/(\d{2})(?=\d)/g, '$1 ')}`;
      }
      
      // Si on ne peut pas formatter, retourner tel quel mais avec des espaces tous les 2 chiffres
      return cleanNumber.replace(/(\d{2})(?=\d)/g, '$1 ');
    };

    // Formater les dates
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', { 
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      }).format(date);
    };

    // Formater les nombres avec des espaces
    const formatNumber = (number) => {
      if (number === undefined || number === null) return '0';
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    // Générer une URL d'avatar
    const getAvatarUrl = (name) => {
      if (!name) return `https://ui-avatars.com/api/?name=User&background=random`;
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff`;
    };

    // Fonctions pour les actions sur les utilisateurs
    const viewUserDetails = (user) => {
      
      activeActionMenu.value = null;
      router.push(`/dashboard/users/${user.id}`);
    };

    const editUser = (user) => {
      
      activeActionMenu.value = null;
      router.push(`/dashboard/users/${user.id}/edit`);
    };

    // Fonctionformat relatif des dates
    const formatTimeAgo = (dateString) => {
      if (!dateString) return 'Non spécifié';
      
      const date = new Date(dateString);
      
      // Tableau des mois en format court
      const months = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];
      
      // Récupérer les composants de la date
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      
      // Retourner la date formatée
      return `${month} ${day}, ${year} - ${hours}:${minutes}`;
    };

    // Fonction pour rediriger vers la page chatbot
    const redirectToChatbotPage = (chatbotId) => {
      if (chatbotId) {
        
        // Utiliser le router pour naviguer vers la page du chatbot
        router.push(`/dashboard/chatbots/${chatbotId}/home`);
      } else {
        
        // Implémentation future: tri par chatbot lorsqu'on clique sur l'en-tête de colonne
      }
    };

    // Fonction pour basculer le tri des chatbots
    const toggleChatbotSort = () => {
      
      
      // Sauvegarder l'état original si ce n'est pas déjà fait
      if (!originalUsers.value.length) {
        originalUsers.value = [...users.value];
      }
      
      if (chatbotSort.value === 'none') {
        // Premier clic : trier par ordre alphabétique ascendant
        chatbotSort.value = 'asc';
        
        // Trier les utilisateurs par nom de chatbot
        const sortedUsers = [...originalUsers.value].sort((a, b) => {
          const botA = (a.bot || '').toLowerCase();
          const botB = (b.bot || '').toLowerCase();
          return botA.localeCompare(botB);
        });
        
        // Mettre à jour la liste des utilisateurs avec la version triée
        users.value = sortedUsers;
      } else {
        // Deuxième clic : revenir à l'ordre d'origine
        chatbotSort.value = 'none';
        users.value = [...originalUsers.value];
      }
    };

    // Fonction pour basculer le menu d'actions
    const toggleActionMenu = (index) => {
      if (activeActionMenu.value === index) {
        activeActionMenu.value = null;
      } else {
        activeActionMenu.value = index;
      }
    };

    // Fonction pour basculer le tri des activités
    const toggleActivitySort = () => {
      if (activitySort.value === 'none') {
        activitySort.value = 'desc';
        users.value = [...users.value].sort((a, b) => {
          const dateA = new Date(a.lastActivity || 0).getTime();
          const dateB = new Date(b.lastActivity || 0).getTime();
          return dateB - dateA;
        });
      } else if (activitySort.value === 'desc') {
        activitySort.value = 'asc';
        users.value = [...users.value].sort((a, b) => {
          const dateA = new Date(a.lastActivity || 0).getTime();
          const dateB = new Date(b.lastActivity || 0).getTime();
          return dateA - dateB;
        });
      } else {
        activitySort.value = 'none';
        // Restaurer l'ordre original
        users.value = [...originalUsers.value];
      }
      
      // Réinitialiser les autres tris
      interactionsSort.value = 'none';
      chatbotSort.value = 'none';
    };

    // Fonction pour ouvrir WhatsApp
    const openWhatsApp = (phone) => {
      if (!phone) return;
      
      // Nettoyer le numéro de téléphone (enlever les espaces et caractères spéciaux)
      const cleanPhone = phone.replace(/\D/g, '');
      
      // Construire l'URL WhatsApp
      const whatsappUrl = `https://wa.me/${cleanPhone}`;
      
      // Ouvrir dans un nouvel onglet
      window.open(whatsappUrl, '_blank');
    };

    // Fonction pour ouvrir la conversation
    const openConversation = (user) => {
      
      router.push(`/dashboard/chat/${user.idbot}/${user.phone}`);
    };

    // Variables pour le bloc Condition
    const chatbotVariables = ref([]);
    const conditions = ref([
      { 
        attribute: '', 
        value: '', 
        operator: 'and',
        searchTerm: '',
        showDropdown: false,
        filteredVariables: [],
        comparison: 'equals',
        // Nouvelles propriétés pour les valeurs
        valueSearchTerm: '',
        valueShowDropdown: false,
        valueLoading: false,
        possibleValues: [],
        filteredValues: []
      }
    ]);

    // Charger les variables dynamiquement depuis l'API
    const loadChatbotVariables = async () => {
      try {
        
        if (!chatbotId.value) {
          console.error("ID du chatbot manquant");
          return;
        }
        
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error("Données utilisateur non trouvées");
          return;
        }
        
        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error("Token non trouvé");
          return;
        }
        
        
        const response = await axios({
          method: 'get',
          url: `${apiBaseUrl}/get/strong/variables/${chatbotId.value}`,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });
        
        
        
        if (response.data && response.data.variables) {
          chatbotVariables.value = response.data.variables;
          
          
          // Initialiser les variables filtrées pour chaque condition
          conditions.value.forEach(cond => {
            cond.filteredVariables = [...chatbotVariables.value];
            
          });
        } else {
          console.error("Aucune variable dans la réponse", response.data);
        }
      } catch (e) {
        console.error("Erreur lors du chargement des variables:", e);
        chatbotVariables.value = [];
      }
    };

    // S'assurer que onMounted appelle bien loadChatbotVariables
    onMounted(async () => {
      
      await loadChatbotVariables();
      
      // Autres fonctions de onMounted...
    });
    
    // Mettre à jour la fonction addCondition pour initialiser correctement les variables filtrées
    const addCondition = () => {
      
      
      // Définir l'opérateur de la dernière condition actuelle à 'and' par défaut
      if (conditions.value.length > 0) {
        const lastCondition = conditions.value[conditions.value.length - 1];
        if (!lastCondition.operator) {
          lastCondition.operator = 'and';
          
        }
      }
      
      // Ajouter la nouvelle condition
      conditions.value.push({ 
        attribute: '', 
        value: '', 
        operator: 'and',  // Opérateur par défaut
        searchTerm: '',
        showDropdown: false,
        filteredVariables: [...chatbotVariables.value],
        comparison: 'equals',
        // Nouvelles propriétés pour les valeurs
        valueSearchTerm: '',
        valueShowDropdown: false,
        valueLoading: false,
        possibleValues: [],
        filteredValues: []
      });
      
      
      
    };
    const removeCondition = (idx) => {
      if (conditions.value.length > 1) {
        conditions.value.splice(idx, 1);
      }
    };

    // Filtrer les variables en fonction de la recherche
    const filterVariables = (cond) => {
      if (!cond.searchTerm || cond.searchTerm.trim() === '') {
        cond.filteredVariables = [...chatbotVariables.value];
        return;
      }
      
      const searchTerm = cond.searchTerm.toLowerCase().trim();
      cond.filteredVariables = chatbotVariables.value.filter(variable => 
        variable.slug.toLowerCase().includes(searchTerm)
      );
    };
    
    // Sélectionner une variable depuis le dropdown
    const selectVariable = (cond, slug) => {
      cond.attribute = slug;
      cond.searchTerm = '';
      cond.showDropdown = false;
      
      // Réinitialiser la valeur et charger les valeurs possibles
      cond.value = '';
      cond.possibleValues = [];
      cond.filteredValues = [];
      cond.valueSearchTerm = '';
      loadVariableValues(cond);
    };
    
    // Mettre à jour clearVariable pour réinitialiser aussi les valeurs
    const clearVariable = (cond) => {
      cond.attribute = '';
      cond.searchTerm = '';
      cond.showDropdown = true;
      
      // Réinitialiser aussi les informations de valeur
      cond.value = '';
      cond.valueSearchTerm = '';
      cond.possibleValues = [];
      cond.filteredValues = [];
    };
    
    // Mettre à jour closeAllDropdowns pour fermer les dropdowns de valeurs
    const closeAllDropdowns = () => {
      conditions.value.forEach(cond => {
        cond.showDropdown = false;
        cond.valueShowDropdown = false;
      });
    };
    
    // Ajouter la méthode pour charger les valeurs possibles d'une variable
    const loadVariableValues = async (cond) => {
      // Si aucun attribut n'est sélectionné, ne rien faire
      if (!cond.attribute) return;
      
      cond.valueLoading = true;
      cond.possibleValues = [];
      cond.filteredValues = [];
      
      try {
        
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error("Données utilisateur non trouvées");
          return;
        }
        
        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error("Token non trouvé");
          return;
        }
        
        const response = await axios({
          method: 'get',
          url: `${apiBaseUrl}/get/strong/variable/values/${chatbotId.value}/${cond.attribute}`,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });
        
        
        
        if (Array.isArray(response.data)) {
          cond.possibleValues = response.data;
          cond.filteredValues = [...response.data];
          
        } else {
          console.warn("Format de réponse inattendu pour les valeurs:", response.data);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des valeurs:", error);
      } finally {
        cond.valueLoading = false;
      }
    };
    
    // Méthode pour gérer le focus sur le champ de valeur
    const handleValueFocus = (cond) => {
      // S'assurer que les valeurs possibles sont chargées
      if (cond.attribute && cond.possibleValues.length === 0) {
        loadVariableValues(cond);
      }
      
      // Ouvrir le dropdown
      cond.valueShowDropdown = true;
    };
    
    // Méthode pour gérer la saisie dans le champ de recherche de valeur
    const handleValueSearchInput = (cond) => {
      cond.valueShowDropdown = true;
      filterValues(cond);
    };
    
    // Méthode pour filtrer les valeurs possibles
    const filterValues = (cond) => {
      if (!cond.valueSearchTerm) {
        cond.filteredValues = [...cond.possibleValues];
        return;
      }
      
      const searchTerm = cond.valueSearchTerm.toLowerCase();
      cond.filteredValues = cond.possibleValues.filter(valueObj => {
        const valueStr = valueObj._id === null ? 'null' : String(valueObj._id).toLowerCase();
        return valueStr.includes(searchTerm);
      });
    };
    
    // Méthode pour sélectionner une valeur
    const selectValue = (cond, value) => {
      cond.value = value === null ? 'null' : String(value);
      cond.valueSearchTerm = '';
      cond.valueShowDropdown = false;
    };
    
    // Méthode pour effacer une valeur
    const clearValue = (cond) => {
      cond.value = '';
      cond.valueSearchTerm = '';
      cond.valueShowDropdown = true;
    };
    
    // Mettre à jour les écouteurs d'événements
    onMounted(() => {
      loadChatbotVariables();
      
      // Ajouter l'écouteur pour fermer les dropdowns
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.variable-dropdown-container') && 
            !event.target.closest('.value-dropdown-container')) {
          closeAllDropdowns();
        }
      });
    });
    
    onUnmounted(() => {
      // Nettoyer l'écouteur d'événements
      document.removeEventListener('click', (event) => {
        if (!event.target.closest('.variable-dropdown-container') && 
            !event.target.closest('.value-dropdown-container')) {
          closeAllDropdowns();
        }
      });
    });

    // Monter le composant
    onMounted(async () => {
      
      // Charger les informations du chatbot
      await loadChatbotInfo();
      // Charger les statistiques du chatbot
      await loadChatbotStats();
      // Charger les statistiques globales en premier
      await loadGlobalStats();
      
      // Charger les utilisateurs initiaux
      await loadUsers(true);

      // Ajouter l'écouteur de clic global
      document.addEventListener('click', handleGlobalClick);
    });

    // Nettoyer les écouteurs d'événements
    onUnmounted(() => {
      document.removeEventListener('click', handleGlobalClick);
      if (searchTimeout.value) {
        clearTimeout(searchTimeout.value);
      }
    });

    const handleLimitChange = () => {
      
      page.value = 1;
      users.value = [];
      loadUsers(true);
    };

    const loadAllUsers = async () => {
      
      loading.value = true;
      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error('❌ Données utilisateur non trouvées');
          return;
        }

        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error('❌ Token non trouvé');
          return;
        }

        const response = await axios({
          method: 'get',
          url: `${apiBaseUrl}/get/strong/users`,
          params: {
            page: 1,
            limit: 20,
            idbotget: chatbotId.value  // Un grand nombre pour obtenir tous les utilisateurs
          },
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });

        if (response.data && response.data.users) {
          const formattedUsers = response.data.users.map(user => ({
            id: user.id_dialog ,
            iduser: user.iduser,
            name: user.user_full_name || 'Sans nom',
            phone:  user.tel  ,
            phonebot: user.telbot ,
            email: user.email || '',
            bot: user.bot_name || 'Non spécifié',
            idbot: user.idbot || null,
            discussions: user.total_discussions || 0,
            lastActivity: user.created_at || new Date().toISOString(),
            isActive: user.is_active || true,
            profileImage: user.user_image_profile || ''
          }));

          users.value = formattedUsers;
          originalUsers.value = formattedUsers;
          hasMoreUsers.value = false;
        }
      } catch (error) {
        console.error('❌ Erreur lors du chargement de tous les utilisateurs:', error);
      } finally {
        loading.value = false;
      }
    };

    // Fonction pour basculer le tri des interactions
    const toggleInteractionsSort = () => {
      if (interactionsSort.value === 'none') {
        interactionsSort.value = 'desc';
        users.value = [...users.value].sort((a, b) => (b.discussions || 0) - (a.discussions || 0));
      } else if (interactionsSort.value === 'desc') {
        interactionsSort.value = 'asc';
        users.value = [...users.value].sort((a, b) => (a.discussions || 0) - (b.discussions || 0));
      } else {
        interactionsSort.value = 'none';
        // Restaurer l'ordre original
        users.value = [...originalUsers.value];
      }
      
      // Réinitialiser les autres tris
      activitySort.value = 'none';
      chatbotSort.value = 'none';
    };

    const loadChatbotInfo = async () => {
      try {
        if (!chatbotId.value) return;
        
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error('❌ Données utilisateur non trouvées');
          return;
        }

        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error('❌ Token non trouvé');
          return;
        }

        const response = await axios({
          method: 'get',
          url: `${apiBaseUrl}/get/strong/chatbot/${chatbotId.value}`,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });

        if (response.data && response.data.chatbot) {
          chatbotInfo.value = response.data.chatbot;
          
        }
      } catch (error) {
        console.error('❌ Erreur lors du chargement des informations du chatbot:', error);
      }
    };

    const loadChatbotStats = async () => {
      try {
        if (!chatbotId.value) return;
        
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error('❌ Données utilisateur non trouvées');
          return;
        }

        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error('❌ Token non trouvé');
          return;
        }

        const response = await axios({
          method: 'get',
          url: `${apiBaseUrl}/get/baddass/kpis/${chatbotId.value}`,
          params: {
            months: selectedPeriod.value,
            days: 3 // Nombre de jours pour les DAU
          },
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });

        if (response.data && response.data.baddas_stats) {
          chatbotStats.value = response.data.baddas_stats;
          
        }
      } catch (error) {
        console.error('❌ Erreur lors du chargement des statistiques du chatbot:', error);
      }
    };

    // Watcher pour recharger les stats quand la période change
    watch(selectedPeriod, () => {
      loadChatbotStats();
    });

    // Nouvelles fonctions pour les tendances DAU
    const calculateDauTrend = (currentIndex) => {
      if (!chatbotStats.value?.dau || currentIndex >= chatbotStats.value.dau.length - 1) return 0;
      const current = chatbotStats.value.dau[currentIndex].totalActiveUsers;
      const previous = chatbotStats.value.dau[currentIndex + 1].totalActiveUsers;
      if (previous === 0) return 0;
      return Number(((current - previous) / previous * 100).toFixed(1));
    };

    const getDauTrend = (currentIndex) => {
      const trend = calculateDauTrend(currentIndex);
      return trend > 0 ? 'trend-up' : trend < 0 ? 'trend-down' : '';
    };

    const calculateRecurringTrend = (currentIndex) => {
      if (!chatbotStats.value?.dau || currentIndex >= chatbotStats.value.dau.length - 1) return 0;
      const current = chatbotStats.value.dau[currentIndex].activeUsersExcludingNewRegistrations;
      const previous = chatbotStats.value.dau[currentIndex + 1].activeUsersExcludingNewRegistrations;
      if (previous === 0) return 0;
      return Number(((current - previous) / previous * 100).toFixed(1));
    };

    const getRecurringTrend = (currentIndex) => {
      const trend = calculateRecurringTrend(currentIndex);
      return trend > 0 ? 'trend-up' : trend < 0 ? 'trend-down' : '';
    };

    const formatDauDate = (dateString) => {
      const date = new Date(dateString);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      if (date.toDateString() === today.toDateString()) {
        return "Aujourd'hui";
      } else if (date.toDateString() === yesterday.toDateString()) {
        return "Hier";
      } else {
        return new Intl.DateTimeFormat('fr-FR', { 
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        }).format(date);
      }
    };

    const formatMonthYear = (year, month) => {
      const date = new Date(year, month - 1);
      return new Intl.DateTimeFormat('fr-FR', { 
        month: 'long',
        year: 'numeric'
      }).format(date);
    };

    const calculateAverageTrend = (currentIndex, data) => {
      if (currentIndex >= data.length - 1) return '';
      const current = data[currentIndex].averageInteractions;
      const previous = data[currentIndex + 1].averageInteractions;
      const percentChange = ((current - previous) / previous * 100);
      const sign = percentChange > 0 ? '+' : '';
      return `${sign}${Math.round(percentChange)}%`;
    };

    const getAverageTrend = (currentIndex, data) => {
      if (currentIndex >= data.length - 1) return '';
      const current = data[currentIndex].averageInteractions;
      const previous = data[currentIndex + 1].averageInteractions;
      return current > previous ? 'trend-up' : 'trend-down';
    };

    // Gérer le focus sur le champ de recherche
    const handleFocusSearch = (cond) => {
      // S'assurer que les variables filtrées sont initialisées
      if (!cond.filteredVariables || cond.filteredVariables.length === 0) {
        cond.filteredVariables = [...chatbotVariables.value];
      }
      // Ouvrir le dropdown
      cond.showDropdown = true;
    };
    
    // Gérer la saisie dans le champ de recherche
    const handleSearchInput = (cond) => {
      // Toujours garder le dropdown ouvert pendant la saisie
      cond.showDropdown = true;
      // Filtrer les variables
      filterVariables(cond);
    };

    // Nouvelle méthode pour valider une variable personnalisée
    const validateCustomVariable = (cond) => {
      if (cond.searchTerm && cond.searchTerm.trim() !== '') {
        // Si une variable est trouvée dans les filtres, utiliser celle-ci
        const foundVariable = cond.filteredVariables.find(v => 
          v.slug.toLowerCase() === cond.searchTerm.toLowerCase()
        );
        
        if (foundVariable) {
          // Si la variable existe dans la liste, l'utiliser
          selectVariable(cond, foundVariable.slug);
        } else {
          // Sinon, créer une variable personnalisée
          const customVar = cond.searchTerm.trim();
          selectVariable(cond, customVar);
          
        }
      }
    };
    
    // Nouvelle méthode pour valider une valeur personnalisée
    const validateCustomValue = (cond) => {
      if (cond.valueSearchTerm && cond.valueSearchTerm.trim() !== '') {
        // Si une valeur est trouvée dans les filtres, utiliser celle-ci
        const foundValue = cond.filteredValues.find(v => 
          String(v._id).toLowerCase() === cond.valueSearchTerm.toLowerCase()
        );
        
        if (foundValue) {
          // Si la valeur existe dans la liste, l'utiliser
          selectValue(cond, foundValue._id);
        } else {
          // Sinon, créer une valeur personnalisée
          const customValue = cond.valueSearchTerm.trim();
          selectValue(cond, customValue);
          
        }
      }
    };

    // Forcer le rechargement des variables (pour débogage)
    const reloadVariables = async () => {
      
      await loadChatbotVariables();
      
      // Réinitialiser les variables filtrées pour chaque condition
      conditions.value.forEach(cond => {
        cond.filteredVariables = [...chatbotVariables.value];
      });
      
      // Afficher un message d'information
      
    };

    // État pour l'ouverture/fermeture du bloc de condition
    const isConditionBlockOpen = ref(false);
    
    // Toggle pour ouvrir/fermer le bloc de condition
    const toggleConditionBlock = () => {
      isConditionBlockOpen.value = !isConditionBlockOpen.value;
    };
    
    // Variables pour afficher le résultat de la requête
    const queryResult = ref(null);
    const showQueryConsole = ref(false);
    const matchingUsers = ref([]);
    const showUsersList = ref(false);
    
    // Fonction de formatage JSON simplifiée avec styles inline pour garantir l'affichage des couleurs
    // Fonction pour récupérer le numéro de téléphone à partir de l'objet utilisateur
    const getUserPhone = (user) => {
      // Vérifier d'abord dans user.infos.tel
      
      if ( user.user_info.tel !== null ) {
        return user.user_info.tel;
      }
      
      // Si user.infos.tel est null ou non défini, chercher dans user.user_details.tel
      if (user.user_details && user.user_details.tel) {
        
        return user.user_details.tel;
      }
      
      // Si le téléphone est directement dans user.tel
      
      
      console.warn(`⚠️ DEBUG: Aucun numéro de téléphone trouvé pour l'utilisateur:`, user);
      return '';
    };
    
    // Fonction pour formater le numéro de téléphone pour l'affichage
    const formatPhoneDisplay = (phone) => {
      if (!phone) return 'Numéro inconnu';
      
      // Si le numéro commence par un code pays, ajouter un +
      if (phone.length > 10 && !phone.startsWith('+')) {
        return '+' + phone;
      }
      return phone;
    };
    
    // Fonction pour ouvrir la conversation avec un utilisateur
    const openChat = (user) => {
      const phone = getUserPhone(user);
      if (!phone) {
        console.error("Numéro de téléphone non disponible");
        return;
      }
      
      const idBot = user.user_info?.idbot || chatbotId.value;
      
      // Rediriger vers la page de chat
      router.push(`/dashboard/chat/${idBot}/${phone}`);
    };
    
    const formatJsonWithHighlighting = (json) => {
      if (!json) return '';
      
      // Styles intégrés directement avec palette de couleurs WhatsApp
      const styles = {
        bracket: 'color:rgb(75, 73, 64); font-weight: bold;',  // vert WhatsApp
        brace: 'color:rgb(39, 31, 34); font-weight: bold;',    // vert foncé WhatsApp
        key: 'color:rgb(37, 36, 32); font-weight: bold;',      // bleu WhatsApp
        number: 'color: #f6628c; font-weight: bold;',   // vert clair WhatsApp
        string: 'color: #128C7E;',                      // vert WhatsApp
        colon: 'color: #888;',                          // gris neutre
        boolean: 'color: #075E54;',                     // vert foncé WhatsApp
        null: 'color: #999; font-style: italic;'        // gris clair italique
      };
      
      try {
        // Échapper les caractères HTML
        const escapeHtml = (str) => {
          return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        };
        
        // Exemple précis pour le format que nous attendons [{"total": 195}]
        if (json && json.length === 1 && json[0].total !== undefined) {
          // Format spécifique pour ce cas exact
          return `<span style="${styles.bracket}">[</span>
  <span style="${styles.brace}">{</span>
    <span style="${styles.key}">"total"</span><span style="${styles.colon}">:</span> <span style="${styles.number}">${json[0].total}</span>
  <span style="${styles.brace}">}</span>
<span style="${styles.bracket}">]</span>`;
        }
        
        // Pour les autres cas, utiliser une version simplifiée
        const jsonString = JSON.stringify(json, null, 2);
        let html = escapeHtml(jsonString);
        
        // Remplacements pour la coloration
        html = html
          // Crochets
          .replace(/\[/g, `<span style="${styles.bracket}">[</span>`)
          .replace(/\]/g, `<span style="${styles.bracket}">]</span>`)
          // Accolades
          .replace(/\{/g, `<span style="${styles.brace}">{</span>`)
          .replace(/\}/g, `<span style="${styles.brace}">}</span>`)
          // Clés et deux-points ensemble
          .replace(/"([^"]+)":/g, `<span style="${styles.key}">"$1"</span><span style="${styles.colon}">:</span>`)
          // Valeurs string
          .replace(/: "([^"]*)"/g, `: <span style="${styles.string}">"$1"</span>`)
          // Nombres
          .replace(/: ([0-9]+)/g, `: <span style="${styles.number}">$1</span>`)
          // Booléens
          .replace(/: (true|false)/g, `: <span style="${styles.boolean}">$1</span>`)
          // Null
          .replace(/: null/g, `: <span style="${styles.null}">null</span>`);
          
        return html;
      } catch (error) {
        console.error('Erreur lors du formatage JSON:', error);
        return JSON.stringify(json, null, 2); // Fallback au format standard
      }
    };
    
    // Vérifier si des conditions sont définies
    const hasConditions = computed(() => {
      return conditions.value.some(cond => cond.attribute && cond.value);
    });
    
    // Vérifier si les conditions sont valides pour la recherche
    const hasValidConditions = computed(() => {
      return conditions.value.some(cond => cond.attribute && cond.value);
    });
    
    // Générer un résumé des conditions pour l'affichage replié
    const getConditionSummary = () => {
      // Filtrer les conditions qui ont à la fois un attribut et une valeur
      const validConditions = conditions.value.filter(cond => cond.attribute && cond.value);
      
      if (validConditions.length === 0) {
        return "Aucune condition définie";
      }
      
      // Limiter à 2 conditions pour le résumé
      const displayConditions = validConditions.slice(0, 2);
      
      // Formater chaque condition
      const summary = displayConditions.map(cond => {
        const comparisonText = cond.comparison === 'equals' ? 'est' : 'n\'est pas';
        return `{{${cond.attribute}}} ${comparisonText} ${cond.value}`;
      }).join(' ET ');
      
      // Ajouter un indicateur s'il y a plus de conditions
      if (validConditions.length > 2) {
        return `${summary} + ${validConditions.length - 2} autre(s)`;
      }
      
      return summary;
    };

    // Méthode pour appliquer les conditions
    const applyConditions = () => {
      
      // Ici, vous pourriez implémenter la logique de filtrage
    };

    // Fonction pour récupérer les utilisateurs correspondant aux conditions
    const fetchMatchingUsers = async () => {
      try {
        // Récupérer le token depuis le localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error("Données utilisateur non trouvées");
          return;
        }
        
        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error("Token non trouvé");
          return;
        }
        
        // Appeler tout de suite la requête pour récupérer les modèles de broadcast
        
        try {
          await fetchBroadcastModels();
          
        } catch (broadcastError) {
          console.error("❌ Erreur lors de la récupération des modèles de broadcast:", broadcastError);
        }
        
        // Filtrer les conditions valides
        const validConditions = conditions.value.filter(
          cond => cond.attribute && cond.value
        );
        
        if (validConditions.length === 0) {
          console.warn("Aucune condition valide à envoyer");
          return;
        }
        
        // Transformer les conditions pour l'API
        const formattedConditions = validConditions.map((cond, index) => {
          // Transformer les opérateurs en symboles
          const comparisonSymbol = cond.comparison === 'equals' ? '=' : '!=';
          const logicalOperator = index < validConditions.length - 1 ? 
            (cond.operator === 'and' ? '&&' : '||') : null;
          
          return {
            idvariable: cond.attribute,
            comparison: comparisonSymbol,
            value: cond.value,
            operator: logicalOperator
          };
        });
        
        // URL pour la requête
        const url = `${apiBaseUrl}/post/strong/conditions/${chatbotId.value}`;
        
        // Format spécifique pour la requête de liste d'utilisateurs
        const requestData = {
          conditions: JSON.stringify(formattedConditions),
          sizing: false // On veut récupérer la liste des utilisateurs, pas juste le compte
        };
        
        
        
        // Afficher un message de chargement
        matchingUsers.value = [];
        showUsersList.value = true;
        
        // Effectuer la requête
        const response = await axios({
          method: 'post',
          url: url,
          data: requestData,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`,
            'Content-Type': 'application/json'
          }
        });
        
        
        
        // Traiter la réponse
        if (response.data && response.data.result) {
          matchingUsers.value = response.data.result;
        } else if (Array.isArray(response.data)) {
          matchingUsers.value = response.data;
        } else {
          console.warn("Format de réponse inattendu:", response.data);
          matchingUsers.value = [];
        }
        
      } catch (error) {
        console.error("Erreur lors de la récupération des utilisateurs:", error);
        matchingUsers.value = [];
      }
    };
    
    // Nouvelle méthode pour envoyer les conditions à l'API
    const sendConditionsToAPI = async () => {
      try {
        
        
        
        // Récupérer le token depuis le localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error("Données utilisateur non trouvées");
          return;
        }
        
        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error("Token non trouvé");
          return;
        }
        
        // Filtrer les conditions valides
        const validConditions = conditions.value.filter(
          cond => cond.attribute && cond.value
        );
        
        
        
        
        if (validConditions.length === 0) {
          console.warn("Aucune condition valide à envoyer");
          return;
        }
        
        // Vérifier les opérateurs avant formatage
        validConditions.forEach((cond, index) => {
          // Si ce n'est pas la dernière condition et qu'il n'y a pas d'opérateur, en définir un par défaut
          if (index < validConditions.length - 1 && !cond.operator) {
            console.warn(`La condition ${index} n'a pas d'opérateur, définition par défaut à 'and'`);
            cond.operator = 'and';
          }
          
          // Log détaillé de chaque condition
        
        });
        
        // Transformer les conditions pour l'API
        const formattedConditions = validConditions.map((cond, index) => {
          // Transformer les opérateurs en symboles
          const comparisonSymbol = cond.comparison === 'equals' ? '=' : '!=';
          const logicalOperator = index < validConditions.length - 1 ? 
            (cond.operator === 'and' ? '&&' : '||') : null;
          
          const formattedCondition = {
            idvariable: cond.attribute,
            comparison: comparisonSymbol,
            value: cond.value,
            operator: logicalOperator
          };
          
          
          
          return formattedCondition;
        });
        
        
        
        
        // Construire l'URL avec l'ID du chatbot
        const url = `${apiBaseUrl}/post/strong/conditions/${chatbotId.value}`;
        
        // Structure de données à envoyer
        const requestData = {
          filters: formattedConditions
        };
        
        // Format alternatif qui pourrait être attendu par le backend
        const alternativeFormat = {
          conditions: JSON.stringify(formattedConditions),
          sizing: true // Paramètre pour retourner le nombre d'utilisateurs
        };
        
        
        
        
        // Réinitialiser les résultats précédents
        showUsersList.value = false;
        matchingUsers.value = [];
        
        // Envoyer la requête à l'API avec le format alternatif
        const response = await axios({
          method: 'post',
          url: url,
          data: alternativeFormat,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`,
            'Content-Type': 'application/json'
          }
        });
        
        
        
        // Stocker le résultat pour l'afficher dans la console
        queryResult.value = response.data.result || response.data;
        showQueryConsole.value = true;
        
        // Gérer la réponse de l'API
        if (response.data && response.data.success) {
          // Si la requête a réussi, rafraîchir la liste des utilisateurs
          
          await loadUsers(true);
        } else {
          console.warn("La requête a réussi mais avec des erreurs:", response.data);
        }
        
      } catch (error) {
        console.error("Erreur lors de l'envoi des conditions:", error.response?.data || error.message || error);
      }
    };

    // État du broadcast pour les utilisateurs correspondants
    const showBroadcastMenu = ref(false);
    const broadcastMessages = ref([]);
    const selectedBroadcast = ref(null);
    const selectedBroadcastId = ref('');
    const broadcastVariables = ref({});
    const broadcastLoading = ref(false);
    const broadcastSending = ref(false);
    const broadcastProgress = ref(0);
    const broadcastSent = ref(false);
    const successCount = ref(0);
    const failedCount = ref(0);
    const broadcastReport = ref([]);
    const showBroadcastReport = ref(false);
    const rawResponses = ref([]);
    
    // Méthode pour afficher/masquer le menu des broadcasts
    const toggleBroadcastMenu = async () => {
      // Charger les modèles si nécessaire, même si on ne fait que cliquer sur le bouton
      if (broadcastMessages.value.length === 0) {
        await fetchBroadcastModels();
      }
      
      showBroadcastMenu.value = !showBroadcastMenu.value;
    };
    
    // Méthode pour gérer la sélection d'un broadcast depuis la liste déroulante
    const handleBroadcastSelection = () => {
      if (!selectedBroadcastId.value) {
        
        return;
      }
      
      
      
      
      // Convertir l'ID en nombre si nécessaire car les IDs peuvent être des chaînes ou des nombres
      const selectedId = Number(selectedBroadcastId.value);
      
      // Trouver le broadcast sélectionné dans la liste
      const broadcast = broadcastMessages.value.find(b => Number(b.id) === selectedId);
      
      if (broadcast) {
        
        // Utiliser la méthode existante pour sélectionner le broadcast
        selectBroadcast(broadcast);
      } else {
        console.error("❌ DEBUG: Broadcast non trouvé pour l'ID:", selectedBroadcastId.value);
        console.error("❌ DEBUG: Types - selectedId:", typeof selectedId, "| Exemple d'ID dans la liste:", typeof broadcastMessages.value[0]?.id);
      }
    };
    
    // Fonction pour basculer l'affichage du rapport détaillé
    const toggleBroadcastReport = () => {
      
      showBroadcastReport.value = !showBroadcastReport.value;
      
      
      // Afficher des infos sur les réponses pour déboguer
      if (showBroadcastReport.value) {
        
        
      }
    };
    
    // Méthode pour charger les modèles de broadcast depuis l'API
    const fetchBroadcastModels = async () => {
      if (!chatbotId.value) {
        console.error("❌ DEBUG: ID du chatbot non disponible pour charger les broadcasts");
        return;
      }
      
      broadcastLoading.value = true;
      
      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error("❌ DEBUG: Données utilisateur non trouvées dans localStorage");
          throw new Error('Veuillez vous reconnecter');
        }
        
        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error("❌ DEBUG: Token non trouvé dans les données utilisateur");
          throw new Error('Session expirée');
        }
        
        // Logs détaillés pour debug
        
        
        
        
        // Envoyer la requête avec le header d'autorisation
        const response = await axios({
          method: 'get',
          url: `${apiBaseUrl}/get/chatbot/models/${chatbotId.value}`,
          headers: {
            'Authorization': `Bearer ${userObj.data.token}`
          }
        });
        
        // Logs détaillés de la réponse
        
        
        
        if (response.data && response.data.models) {
          broadcastMessages.value = response.data.models;
          
          broadcastMessages.value.forEach((model, index) => {
             
          });
        } else {
          console.warn("⚠️ DEBUG: Format de réponse inattendu pour les broadcasts:", response.data);
          broadcastMessages.value = [];
        }
        
        return response.data;
      } catch (error) {
        console.error("❌ DEBUG: Erreur lors du chargement des modèles de broadcast:", error);
        console.error("❌ DEBUG: Détails:", error.response?.data || error.message || error);
        if (error.response) {
          console.error("❌ DEBUG: Statut HTTP:", error.response.status);
          console.error("❌ DEBUG: Headers:", error.response.headers);
        }
        broadcastMessages.value = [];
        throw error;
      } finally {
        broadcastLoading.value = false;
      }
    };
    
    // Méthode pour sélectionner un broadcast
    const selectBroadcast = (broadcast) => {
      
      
      if (!broadcast || !broadcast.content) {
        console.error("❌ DEBUG: Broadcast invalide ou sans contenu:", broadcast);
        return;
      }
      
      selectedBroadcast.value = broadcast;
      selectedBroadcastId.value = broadcast.id;
      // Initialiser broadcastVariables comme un objet vide
      broadcastVariables.value = {};
      showBroadcastMenu.value = false;
      
      try {
        // Extraire les variables du contenu (format {{number}})
        const regex = /\{\{(\d+)\}\}/g;
        const variables = [];
        let match;
        
        // Vérifier que le contenu existe avant d'exécuter regex
        if (broadcast.content) {
          while ((match = regex.exec(broadcast.content)) !== null) {
            variables.push(match[1]); // Capturer le nombre entre les accolades
          }
          
          
          
          // Initialiser les variables avec des valeurs vides
          variables.forEach(varNumber => {
            broadcastVariables.value[varNumber] = '';
          });
          
          
        }
      } catch (error) {
        console.error("❌ DEBUG: Erreur lors de l'extraction des variables:", error);
        // Assurer que broadcastVariables est au moins un objet vide en cas d'erreur
        broadcastVariables.value = {};
      }
    };
    
    // Formater le message de broadcast pour l'aperçu
    const getFormattedBroadcastMessage = () => {
      if (!selectedBroadcast.value || !selectedBroadcast.value.content) return '';
      
      let message = selectedBroadcast.value.content;
      
      // Vérifier que broadcastVariables.value n'est pas null ou undefined avant d'utiliser Object.entries
      if (broadcastVariables.value) {
        Object.entries(broadcastVariables.value).forEach(([key, value]) => {
          message = message.replace(`{{${key}}}`, value || `[Variable ${key}]`);
        });
      }
      
      return message;
    };
    
    // Envoyer le broadcast à tous les utilisateurs correspondants
    const sendBroadcastToUsers = async () => {
      if (!selectedBroadcast.value || matchingUsers.value.length === 0) {
        console.error("❌ DEBUG: Broadcast ou utilisateurs manquants");
        return;
      }
      
      broadcastSending.value = true;
      broadcastProgress.value = 0;
      successCount.value = 0;
      failedCount.value = 0;
      broadcastReport.value = [];
      rawResponses.value = [];
      
      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          console.error("❌ DEBUG: Données utilisateur non trouvées dans localStorage");
          throw new Error("Données utilisateur non trouvées");
        }
        
        const userObj = JSON.parse(userData);
        if (!userObj.data?.token) {
          console.error("❌ DEBUG: Token non trouvé dans les données utilisateur");
          throw new Error("Token non trouvé");
        }
        
        
        
        
        // Parcourir tous les utilisateurs et envoyer le broadcast à chacun
        for (let i = 0; i < matchingUsers.value.length; i++) {
          const user = matchingUsers.value[i];
          const phone = getUserPhone(user);
          const idBot = user.user_info?.idbot || chatbotId.value;
          
          // Créer un objet rapport pour cet envoi
          const reportEntry = {
            index: i + 1,
            phone: phone || 'Numéro manquant',
            status: 'Non traité',
            messageId: null,
            errorDetails: null,
            timestamp: new Date().toISOString()
          };
          
          if (!phone || !idBot) {
            console.warn(`⚠️ DEBUG: Informations manquantes pour l'utilisateur ${i}:`, user);
            reportEntry.status = 'Erreur';
            reportEntry.errorDetails = 'Numéro de téléphone ou ID du chatbot manquant';
            broadcastReport.value.push(reportEntry);
            failedCount.value++;
            continue;
          }
          
          
          
          // Effectuer la requête d'envoi avec la nouvelle API et toutes les informations disponibles du chatbot
          try {
            // Construire les données de la requête en incluant les informations du chatbot
            const requestData = {
              idbot: idBot,
              phone: phone,
              // Informations du modèle de broadcast sélectionné
               title: selectedBroadcast.value.title,
               langage: selectedBroadcast.value.langage || '',
               // Inclure toutes les informations disponibles du chatbot
              chatbot: chatbotInfo.value || {}
            };
            
            
            
            
            // Attendre la réponse de l'API pour vérifier si l'envoi a réussi
            
            
            const response = await axios({
              method: 'post',
              url: `${apiBaseUrl}/strong/send/chatbot/broadcast`,
              data: requestData,
              headers: {
                'Authorization': `Bearer ${userObj.data.token}`,
                'Content-Type': 'application/json'
              }
            });
            
            // Analyser la réponse
            
            
            // Ajouter la réponse brute à la liste des réponses
            const rawResponse = {
              phone,
              data: response.data,
              isSuccess: false,
              timestamp: new Date().toISOString()
            };
            
            // Vérifier le statut selon la structure exacte fournie
            // {message: "retour message", data: {messaging_product: "whatsapp", contacts: [...], messages: [{id: "...", message_status: "accepted"}]}}
            const messageStatus = response.data?.data?.messages?.[0]?.message_status;
            
            
            if (messageStatus === 'accepted') {
              // Message accepté
              successCount.value++;
              const messageId = response.data.data.messages[0].id;
              
              
              // Mettre à jour l'entrée du rapport
              reportEntry.status = 'Succès';
              reportEntry.messageId = messageId;
              rawResponse.isSuccess = true;
              
              // Afficher les détails du contact
              if (response.data.data.contacts && response.data.data.contacts.length > 0) {
                
                reportEntry.waId = response.data.data.contacts[0].wa_id;
              }
            } else {
              // Message non accepté ou format de réponse inattendu
              failedCount.value++;
              console.warn(`⚠️ DEBUG: Statut du message non accepté ("${messageStatus}") pour ${phone}`);
              reportEntry.status = 'Échec';
              reportEntry.errorDetails = `Statut du message: ${messageStatus || 'non trouvé'}`;
            }
          } catch (sendError) {
            failedCount.value++;
            console.error(`❌ DEBUG: Erreur lors de l'envoi à ${phone}:`, sendError.response?.data || sendError.message);
            reportEntry.status = 'Erreur';
            reportEntry.errorDetails = sendError.response?.data?.message || sendError.message || 'Erreur inconnue';
          }
          
          // Ajouter l'entrée au rapport
          broadcastReport.value.push(reportEntry);
          
          // Mettre à jour la progression
          broadcastProgress.value = i + 1;
          
          // Pause courte pour éviter de surcharger le serveur
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        // Afficher le résumé des envois
        
        
        
        // Marquer comme terminé
        broadcastSent.value = true;
        showBroadcastReport.value = true;
        selectedBroadcast.value = null;
        selectedBroadcastId.value = '';
        
      } catch (error) {
        console.error("❌ DEBUG: Erreur générale lors de l'envoi des broadcasts:", error);
        console.error("❌ DEBUG: Détails:", error.response?.data || error.message);
        alert(`Erreur lors de l'envoi: ${error.message}`);
      } finally {
        broadcastSending.value = false;
      }
    };

          return {
      users,
      loading,
      hasMoreUsers,
      scrollContainer,
      searchQuery,
      totalUsers,
      totalDiscussions,
      totalChatbots,
      statsLoading,
      statsError,
      globalStats,
      chatbotSort,
      chatbotInfo,
      chatbotStats,
      selectedPeriod,
      periodOptions,
      toggleChatbotSort,
      loadUsers,
      loadMoreUsers,
      loadGlobalStats,
      refreshGlobalStats,
      debounceSearch,
      refreshUsers,
      formatPhoneNumber,
      formatDate,
      formatNumber,
      getAvatarUrl,
      viewUserDetails,
      editUser,
      formatTimeAgo,
      redirectToChatbotPage,
      activeActionMenu,
      toggleActionMenu,
      activitySort,
      toggleActivitySort,
      handleLimitChange,
      loadAllUsers,
      selectedLimit,
      openWhatsApp,
      interactionsSort,
      toggleInteractionsSort,
      showFilterMenu,
      filters,
      activeFilters,
      toggleFilterMenu,
      applyFilters,
      clearFilters,
      openConversation,
      chatbotId,
      calculateDauTrend,
      getDauTrend,
      calculateRecurringTrend,
      getRecurringTrend,
      formatDauDate,
      selectedView,
      formatMonthYear,
      calculateAverageTrend,
      getAverageTrend,
      chatbotVariables,
      conditions,
      addCondition,
      removeCondition,
      filterVariables,
      selectVariable,
      closeAllDropdowns,
      handleFocusSearch,
      handleSearchInput,
      reloadVariables,
      clearVariable,
      handleValueFocus,
      handleValueSearchInput,
      selectValue,
      clearValue,
      isConditionBlockOpen,
      toggleConditionBlock,
      hasConditions,
      hasValidConditions,
      getConditionSummary,
      applyConditions,
      validateCustomVariable,
      validateCustomValue,
      sendConditionsToAPI,
      queryResult,
      showQueryConsole,
      formatJsonWithHighlighting,
      matchingUsers,
      showUsersList,
      fetchMatchingUsers,
      getUserPhone,
      formatPhoneDisplay,
      openChat,
      showBroadcastMenu,
      broadcastMessages,
      selectedBroadcast,
      selectedBroadcastId,
      broadcastLoading,
      broadcastSending,
      broadcastProgress,
      broadcastSent,
      successCount,
      failedCount,
      broadcastReport,
      showBroadcastReport,
      rawResponses,
      toggleBroadcastMenu,
      fetchBroadcastModels,
      selectBroadcast,
      handleBroadcastSelection,
      toggleBroadcastReport,
      getFormattedBroadcastMessage,
      sendBroadcastToUsers,
    };
  }
};
</script>

<style scoped>
/* Couleurs WhatsApp */
:root {
  --whatsapp-teal: #25D366;
  --whatsapp-green: #128C7E;
  --whatsapp-light-green: #dcf8c6;
  --whatsapp-blue: #34B7F1;
  --whatsapp-dark: #075E54;
}

.all-users-container {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: var(--bg-color);
  color: #37352f;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.users-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 16px 0px 32px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 32px;
}

/* Nouvelles cartes de statistiques inspirées de DashboardStats */
.stats-card {
  background: linear-gradient(135deg, var(--whatsapp-green), var(--whatsapp-dark));
  border-radius: 16px;
  padding: 20px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.stats-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.15), transparent 80%);
  z-index: 0;
}

/* Nouveaux patterns pour les cartes de statistiques */
.stats-card:nth-child(1) {
  background: linear-gradient(135deg, #128C7E, #075E54);
}

.stats-card:nth-child(1)::after {
  content: '';
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  border-radius: 50%;
  top: -70px;
  right: -70px;
  z-index: 0;
}

.stats-card:nth-child(2) {
  background: linear-gradient(135deg, #34B7F1, #0277BD);
}

.stats-card:nth-child(2)::after {
  content: '';
  position: absolute;
  width: 120px;
  height: 120px;
  border: 15px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  bottom: -80px;
  left: -60px;
  z-index: 0;
}

.stats-card:nth-child(3) {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
}

.stats-card:nth-child(3)::after {
  content: '';
  position: absolute;
  width: 100px;
  height: 200px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transform: rotate(-45deg);
  top: -50px;
  right: -20px;
  z-index: 0;
}

/* Animation de pulsation pour les cercles icons */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.circle-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  animation: pulse 2s infinite;
}

.stats-card:nth-child(1) .circle-icon {
  background: rgba(255, 255, 255, 0.25);
  animation-delay: 0s;
}

.stats-card:nth-child(2) .circle-icon {
  background: rgba(255, 255, 255, 0.25);
  animation-delay: 0.5s;
}

.stats-card:nth-child(3) .circle-icon {
  background: rgba(255, 255, 255, 0.25);
  animation-delay: 1s;
}

.circle-icon svg {
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.2));
}

.stats-info {
  flex: 1;
  z-index: 1;
}

.stats-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.stats-value {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.stats-value .number {
  font-size: 2.2rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: -0.5px;
}

.refresh-stats {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  opacity: 0;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.stats-card:hover .refresh-stats {
  opacity: 1;
}

.refresh-stats:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(30deg);
}

.table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0 32px 16px;
  width: 100%;
  box-sizing: border-box;
}

.search-container {
  position: relative;
  width: 320px;
  transition: all 0.3s ease;
}

.search-container input {
  width: 100%;
  padding: 12px 16px 12px 44px;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  background: #f0f0f0;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  color: #37352f;
}

.search-container input::placeholder {
  color: #37352f;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.search-container input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-1px);
}

.search-container input:focus::placeholder {
  opacity: 0.4;
  transform: translateX(4px);
}

.search-container svg {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: #37352f;
  opacity: 0.6;
  transition: all 0.3s ease;
  width: 18px;
  height: 18px;
}

.search-container input:focus + svg {
  opacity: 0.8;
  transform: translateY(-50%) scale(1.1);
}

/* Animation de focus */
@keyframes searchFocus {
  0% {
    box-shadow: 0 0 0 0 rgba(18, 140, 126, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(18, 140, 126, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(18, 140, 126, 0);
  }
}

.search-container input:focus {
  animation: searchFocus 1s ease-out;
}

/* Style pour le mode sombre */
@media (prefers-color-scheme: dark) {
  .search-container input {
    background: #ffffff;
    border-color: #128C7E;
    color: #075E54;
  }

  .search-container input::placeholder {
    color: #128C7E;
    opacity: 0.7;
  }

  .search-container svg {
    color: #128C7E;
  }

  .search-container input:focus {
    border-color: #25D366;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.15);
  }
}

.table-actions {
  display: flex;
  gap: 12px;
  position: relative;
}

.filter-button {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  color: #37352f;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-button:hover {
  background: #f7f7f7;
  border-color: var(--whatsapp-green);
}

.filter-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background: var(--whatsapp-green);
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  min-width: 240px;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}

.filter-section {
  margin-bottom: 16px;
}

.filter-section:last-child {
  margin-bottom: 0;
}

.filter-section h4 {
  font-size: 14px;
  color: #666;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  color: #37352f;
  transition: all 0.2s;
}

.filter-option:hover {
  color: var(--whatsapp-green);
}

.filter-option input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  accent-color: var(--whatsapp-green);
}

.filter-actions {
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
  margin-top: 16px;
}

.clear-filters {
  width: 100%;
  padding: 8px;
  background: #f5f5f5;
  border: none;
  border-radius: 4px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.clear-filters:hover {
  background: #e0e0e0;
  color: #37352f;
}

.add-user-button {
  background: var(--whatsapp-green);
  color: white;
  border: none;
}

.add-user-button:hover {
  background: var(--whatsapp-dark);
}

.users-list-container {
  flex: 1;
  margin: 0;
  padding: 0 32px 32px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.users-table {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  font-size: 14px;
}

thead {
  background: transparent;
  position: sticky;
  top: 0;
  z-index: 10;
}

tbody {
  display: block;
  max-height: calc(15 * 72px); /* 72px est la hauteur approximative d'une ligne (padding + contenu) */
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(55, 53, 47, 0.3) transparent;
}

tbody::-webkit-scrollbar {
  width: 6px;
}

tbody::-webkit-scrollbar-track {
  background: transparent;
}

tbody::-webkit-scrollbar-thumb {
  background-color: rgba(55, 53, 47, 0.3);
  border-radius: 3px;
}

thead, tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

/* Définition des largeurs de colonnes */
th, td {
  padding: 16px;
  text-align: left;
}

/* Colonne utilisateur */
th:nth-child(1), td:nth-child(1) {
  width: 20%;
}

/* Colonne chatbot */
th:nth-child(2), td:nth-child(2) {
  width: 15%;
}

/* Colonne interactions */
th:nth-child(3), td:nth-child(3) {
  width: 15%;
  text-align: center;
}

/* Colonne dernière activité */
th:nth-child(4), td:nth-child(4) {
  width: 23%;
}

/* Colonne actions */
th:nth-child(5), td:nth-child(5) {
   
  text-align: center;
}

tbody tr {
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

tbody td {
  padding: 16px;
  border: none;
  color: #37352f;
  background: #f0f0f0;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  height: 100%;
  vertical-align: middle;
}

tbody tr:hover td {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  transform: translateY(-2px);
 }

tbody tr td:first-child {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

tbody tr td:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

.checkbox-cell {
  width: 40px;
  text-align: center;
}

.checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
}

.user-cell {
  min-width: 240px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-indicator {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #d1d5db;
  border: 2px solid white;
}

.status-indicator.active {
  background-color: var(--whatsapp-teal);
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  font-weight: 500;
  color: #37352f;
}

.user-email {
  font-size: 12px;
  color: #888;
}

.access-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.access-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #f0f0f0;
  color: #666;
}

.access-tag.admin {
  background: rgba(18, 140, 126, 0.1);
  color: #128C7E;
}

.access-tag.data {
  background: #128C7E;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
}

.access-tag.data:hover {
  background: #075E54;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(7, 94, 84, 0.2);
}

.actions-cell {
  width: 60px;
  text-align: center;
}

.table-action-button {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  cursor: pointer;
}

.table-action-button:hover {
  background: #f0f0f0;
  color: #37352f;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin-top: 16px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
}

.pagination-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  color: #666;
}

.users-per-page {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.users-per-page::before {
  content: 'Afficher';
  color: #666;
  font-size: 14px;
}

.users-per-page select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 6px 32px 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: white;
  color: #37352f;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
}

.users-per-page select:hover {
  border-color: #25D366;
  background-color: #f8f8f8;
}

.users-per-page select:focus {
  outline: none;
  border-color: #25D366;
  box-shadow: 0 0 0 2px rgba(37, 211, 102, 0.1);
}

.users-per-page select option {
  padding: 8px;
  background-color: white;
  color: #37352f;
}

.users-per-page::after {
  content: 'utilisateurs';
  color: #666;
  font-size: 14px;
  margin-left: 4px;
}

.load-more-container {
  display: flex;
  justify-content: center;
}

.load-more-button {
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  background: white;
  color: #37352f;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.load-more-button:hover {
  background: #f7f7f7;
}

.loading-container, .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #888;
}

.loader {
  width: 32px;
  height: 32px;
  border: 2px solid rgba(18, 140, 126, 0.1);
  border-radius: 50%;
  border-top-color: var(--whatsapp-green);
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.empty-state svg {
  color: #ccc;
  margin-bottom: 16px;
}

.action-button {
  background: var(--whatsapp-green);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  margin-top: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.action-button:hover {
  background: var(--whatsapp-dark);
}

.loading-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  color: #888;
}

.loading-more .loader {
  width: 24px;
  height: 24px;
  margin-bottom: 8px;
}

.end-message {
  padding: 16px;
  color: #888;
  text-align: center;
}

.chatbot-header {
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.chatbot-header:hover {
  color: var(--whatsapp-green);
}

.chatbot-header svg {
  transition: transform 0.2s, color 0.2s;
}

.chatbot-header:hover svg {
  transform: scale(1.1);
}

.sort-active {
  color: var(--whatsapp-green);
}

.interactions-header {
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
  width: 100%;
}

.interactions-header:hover {
  color: var(--whatsapp-green);
}

.interactions-header svg {
  transition: transform 0.2s, color 0.2s;
  margin-left: 4px;
}

.interactions-header:hover svg {
  transform: scale(1.1);
}

.interactions-cell {
  text-align: center;
  width: 120px;
}

.interactions-count {
  font-weight: 500;
  color: #37352f;
  background: rgba(37, 211, 102, 0.15);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 6px 12px;
  border-radius: 8px;
  display: inline-block;
  min-width: 40px;
  text-align: center;
  transition: all 0.3s ease;
}

/* Responsive */
@media (max-width: 1024px) {
  .users-stats {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .users-header, .page-title-section, .users-stats, .table-controls {
    padding-left: 16px;
    padding-right: 16px;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
  
  .users-list-container {
    margin: 0;
    padding: 0 16px 16px;
    width: 100%;
  }
  
  .breadcrumb {
    display: none;
  }
}

/* Styles pour le menu d'actions */
.actions-dropdown {
  position: relative;
}

.action-menu {
  position: absolute;
  right: 0;
  top: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  z-index: 100;
  overflow: hidden;
  margin-top: 4px;
}

.action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: none;
  color: #37352f;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.action-item:hover {
  background: #f5f5f5;
  color: var(--whatsapp-green);
}

.action-item svg {
  color: #666;
}

.action-item:hover svg {
  color: var(--whatsapp-green);
}

.action-icons {
  display: flex;
  gap: 12px;
  justify-content: center;
  height: 100%;
  align-items: center;
  min-height: 40px; /* Pour garantir une hauteur minimale cohérente */
  padding-bottom: 35px;
  padding-top: 25px;
}

.action-icon-container {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.action-icon-container:hover {
  background-color: #25D366;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
}

.action-icon-container svg {
  transition: all 0.2s ease;
}

.action-icon-container:hover svg {
  transform: scale(1.1);
  stroke: white;
}

/* Tooltip styles */
.action-icon-container::after {
  content: attr(title);
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(37, 211, 102, 0.9);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
  z-index: 100;
}

.action-icon-container:hover::after {
  opacity: 1;
}

.chatbot-name-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
}

.chatbot-name-link:hover {
  transform: translateY(-1px);
}

.chatbot-name-link:hover .settings-icon {
  opacity: 1;
  transform: rotate(45deg);
}

.settings-icon {
  opacity: 0.6;
  transition: all 0.3s ease;
}

.growth-chart-section {
  padding: 0 32px;
  margin-bottom: 32px;
}

@media (max-width: 768px) {
  .growth-chart-section {
    padding: 0 16px;
  }
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.chart-header h3 {
  font-size: 1.25rem;
  font-weight: 500;
  color: #888;
  margin: 0;
}

.period-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.period-selector label {
  font-size: 14px;
  color: #666;
}

.period-select {
  padding: 8px 32px 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  color: #37352f;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  transition: all 0.2s ease;
}

.period-select:hover {
  border-color: #25D366;
}

.period-select:focus {
  outline: none;
  border-color: #25D366;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
}

.dau-overview {
  padding: 0 32px;
  margin-bottom: 32px;
}

.dau-header {
  margin-bottom: 24px;
}

.dau-header h2 {
  font-size: 1.25rem;
  font-weight: 500;
  color: #888;
  margin: 0;
}

.dau-metrics-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.dau-stats-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.dau-stats-card::before {
  display: none;
}

.stats-card-date {
  padding: 12px 20px;
  color: #128C7E;
  font-size: 0.9rem;
  font-weight: 500;
  background: rgba(18, 140, 126, 0.05);
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(18, 140, 126, 0.1);
}

.stats-card-content {
  padding: 20px;
  position: relative;
  z-index: 1;
}

.stats-main-metric {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.circle-icon.users {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: #128C7E;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(18, 140, 126, 0.15);
}

.stats-info {
  flex: 1;
}

.stats-label {
  font-size: 0.9rem;
  color: #fff;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stats-value .number {
  font-size: 2.2rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.stats-value .number-dau {
  font-size: 2.2rem;
  font-weight: 700;
  color: #128C7E;
  letter-spacing: -0.5px;
}

.stats-secondary-metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(18, 140, 126, 0.1);
  margin-top: 16px;
}

.secondary-metric {
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  background: rgba(18, 140, 126, 0.03);
}

.metric-label {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 8px;
}

.metric-value {
  font-size: 1.4rem;
  font-weight: 600;
  color: #128C7E;
}

.metric-value.highlight {
  color: #25D366;
}

.dau-stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(18, 140, 126, 0.1);
  transition: all 0.3s ease;
}

.circle-icon.users svg {
  filter: none;
}

/* Mise à jour de l'animation de pulsation pour les nouvelles couleurs */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(18, 140, 126, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(18, 140, 126, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(18, 140, 126, 0);
  }
}

@media (max-width: 1024px) {
  .dau-metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .dau-overview {
    padding: 0 16px;
  }

  .dau-metrics-grid {
    grid-template-columns: 1fr;
  }
}

/* Animation de pulsation existante */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

/* Styles pour le sélecteur de vue */
.view-selector {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 0 16px;
}

.view-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 8px;
}

.view-option:hover {
  background: rgba(30, 163, 85, 0.1);
  color: #1EA355;
}

.view-option.active {
  background: rgba(30, 163, 85, 0.1);
  color: #1EA355;
  font-weight: 500;
}

.view-option svg {
  color: currentColor;
}

.playground-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #1EA355;
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.playground-btn:hover {
  background: #167F42;
  transform: translateY(-1px);
}

.playground-btn svg {
  transition: transform 0.2s ease;
}

.playground-btn:hover svg {
  transform: scale(1.1);
}

.jarvis-btn {
  margin-left: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #7FC6A6 0%, #667eea 100%);
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(127, 198, 166, 0.3);
}

.jarvis-btn:hover {
  background: linear-gradient(135deg, #6bb394 0%, #5a6fd8 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(127, 198, 166, 0.4);
}

.jarvis-btn .brain-icon {
  transition: all 0.3s ease;
  color: #ffffff;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.jarvis-btn:hover .brain-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.2));
}

.average-chart-section {
  padding: 0 32px;
  margin-bottom: 32px;
}

.average-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 24px;
}

.average-stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;
}

.average-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(18, 140, 126, 0.1);
}

.month-label {
  font-size: 0.9rem;
  color: #128C7E;
  font-weight: 500;
  text-transform: capitalize;
}

.average-value {
  font-size: 2rem;
  font-weight: 600;
  color: #37352f;
  display: flex;
  flex-direction: column;
}

.average-unit {
  font-size: 0.8rem;
  color: #666;
  font-weight: normal;
  margin-top: 4px;
}

.trend-indicator {
  font-size: 0.9rem;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-flex;
  align-self: flex-start;
}

.trend-indicator.trend-up {
  background: rgba(37, 211, 102, 0.1);
  color: #25D366;
}

.trend-indicator.trend-up::before {
  content: '↑';
  margin-right: 4px;
}

.trend-indicator.trend-down {
  background: rgba(255, 77, 77, 0.1);
  color: #ff4d4d;
}

.trend-indicator.trend-down::before {
  content: '↓';
  margin-right: 4px;
}

@media (max-width: 768px) {
  .average-chart-section {
    padding: 0 16px;
  }

  .average-stats-grid {
    grid-template-columns: 1fr;
  }
}

/* Styles pour le bloc Condition (replié par défaut) */
.condition-block {
  margin: 0 32px 24px 32px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.condition-header {
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid transparent;
  transition: background-color 0.2s;
}

.condition-title {
  font-weight: 600;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
}

.condition-title svg {
  opacity: 0.6;
}

.condition-content {
  padding: 16px 24px 24px 24px;
  animation: slideDown 0.3s ease;
  background-color: #fcfcfc;
}

/* Nouvelles classes pour le style "When/Then" */
.condition-section {
  margin-bottom: 16px;
  position: relative;
}

.condition-section:last-child {
  margin-bottom: 0;
}

.condition-section-label {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  font-weight: 500;
  color: #666;
}

.condition-section-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
}

/* Mise à jour des styles de ligne */
.condition-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  padding: 0;
  background-color: transparent;
  border-radius: 8px;
  position: relative;
  width: 100%;
}

.condition-row::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #f0f0f0;
  z-index: 0;
}

.condition-row:last-child {
  margin-bottom: 0;
}

/* Réserver un espace pour le bouton de suppression */
.remove-condition-btn, 
.remove-condition-placeholder {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-right: 6px;
}

.remove-condition-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 0.6;
}

.remove-condition-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* Assure une taille uniforme pour l'opérateur de condition */
.condition-operator,
.condition-operator-spacer {
  width: 80px;
  flex-shrink: 0;
  min-width: 80px;
}

/* Garde l'espace mais cache l'élément */
.invisible {
  visibility: hidden;
  pointer-events: none;
}

/* Mise à jour des champs pour largeur fixe */
.variable-dropdown-container,
.value-dropdown-container {
  position: relative;
  min-width: 200px;
  width: 200px;
  flex: 1;
  height: 42px;
  display: flex;
  align-items: center;
}

.condition-comparison {
  min-width: 180px;
  flex-shrink: 0;
  width: 180px;
}

.condition-label {
  width: 70px;
  color: #888;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.variable-search,
.condition-value {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 0.95rem;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
  transition: all 0.2s ease;
  height: 42px;
  box-sizing: border-box;
}

.variable-search:focus,
.condition-value:focus {
  border-color: #4A90E2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
  outline: none;
}

.variable-tag,
.value-tag {
  display: inline-flex;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  transition: transform 0.2s;
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.variable-tag {
  background-color: #4A90E2;
  color: white;
}

.value-tag {
  background-color: #2ecc71;
  color: white;
}

.variable-tag:hover,
.value-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.08);
}

/* Mise à jour des opérateurs */
.condition-comparison,
.condition-operator {
  min-width: 180px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: white;
  font-size: 0.95rem;
  color: #444;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}

.condition-comparison:hover,
.condition-operator:hover {
  border-color: #4A90E2;
}

.condition-comparison:focus,
.condition-operator:focus {
  outline: none;
  border-color: #4A90E2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
}

/* Boutons d'action */
.add-condition-btn {
  margin-top: 16px;
  width: auto;
  height: auto;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: white;
  color: #128C7E;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}

.add-condition-btn:hover {
  background-color: #f8f8f8;
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.08);
}

.remove-condition-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  transition: all 0.2s ease;
  margin-right: 6px;
  opacity: 0.6;
}

.remove-condition-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* Mise à jour des dropdowns */
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  z-index: 100;
  margin-top: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.dropdown-item {
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f5f5f5;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover, 
.dropdown-item.highlight {
  background-color: #f0f7ff;
}

.dropdown-custom-item {
  padding: 10px 16px;
  background-color: #f8f8f8;
  border-top: 1px dashed #e0e0e0;
  color: #666;
  font-style: italic;
  text-align: center;
  font-size: 0.9rem;
}

.dropdown-custom-item span {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(74, 144, 226, 0.1);
}

.condition-toggle svg {
  transition: transform 0.3s ease;
}

.condition-toggle svg.rotated {
  transform: rotate(180deg);
}

.condition-summary {
  font-size: 0.9rem;
  color: #666;
  background: #f8f8f8;
  padding: 6px 12px;
  border-radius: 6px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.condition-label {
  width: 70px;
  color: #888;
  font-size: 0.9rem;
}

.condition-operator-spacer {
  width: 80px;
}

.dropdown-loading, .dropdown-empty {
  padding: 12px;
  text-align: center;
  color: #888;
  font-size: 0.9rem;
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.remove-tag-btn {
  background: rgba(0,0,0,0.1);
  border: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s;
}

.remove-tag-btn:hover {
  background: rgba(0,0,0,0.2);
}

.search-action-container {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.search-conditions-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  background: #128C7E;
  border: none;
  font-size: 15px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(18, 140, 126, 0.3);
}

.search-conditions-btn:hover {
  background: #075E54;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(18, 140, 126, 0.4);
}

.search-conditions-btn:disabled {
  background: #ccc;
  color: #666;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.search-conditions-btn svg {
  stroke: white;
}

/* Styles pour la console de résultat de requête - Version claire */
.query-console-container {
  margin-top: 16px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  animation: fadeIn 0.3s ease;
  border: 1px solid #f0f0f0;
}

.query-console-header {
  background: #f8f8f8;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #128C7E;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.console-close-btn {
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.console-close-btn:hover {
  color: #128C7E;
  background: rgba(18, 140, 126, 0.1);
}

.query-console-content {
  padding: 16px;
  max-height: 300px;
  overflow: auto;
  background: #fafafa;
}

.query-console-content pre {
  margin: 0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', monospace;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
}

.query-console-actions {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
}

.view-users-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background: #128C7E;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.view-users-btn:hover {
  background: #075E54;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(18, 140, 126, 0.2);
}

/* Styles pour la liste des utilisateurs */
.matching-users-container {
  margin-top: 16px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  animation: fadeIn 0.3s ease;
  border: 1px solid #f0f0f0;
}

.matching-users-header {
  background: #f8f8f8;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #128C7E;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.matching-users-content {
  padding: 16px;
  max-height: 300px;
  overflow: auto;
}

.no-users {
  color: #888;
  text-align: center;
  font-style: italic;
  padding: 20px 0;
}

.user-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.user-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f0f8ff;
  border: 1px solid #e0f0ff;
  border-radius: 30px;
  padding: 6px 12px;
  font-size: 14px;
  color: #075E54;
  cursor: pointer;
  transition: all 0.2s;
}

.user-tag:hover {
  background: #e0f0ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(18, 140, 126, 0.15);
}

.user-tag svg {
  color: #128C7E;
}

/* Coloration syntaxique pour JSON */
.json-key {
  color: #0b7285;
  font-weight: 600;
}

.json-string {
  color: #2e7d32;
}

.json-number {
  color: #e65100;
  font-weight: bold;
}

.json-boolean {
  color: #7b1fa2;
}

.json-null {
  color: #999;
  font-style: italic;
}

.json-bracket {
  color: #d81b60;
  font-weight: bold;
}

.json-brace {
  color: #1565c0;
  font-weight: bold;
}

.json-colon {
  color: #555;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.broadcast-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  z-index: 100;
  margin-top: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.broadcast-menu-header {
  background: #f8f8f8;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #128C7E;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.broadcast-menu-content {
  padding: 16px;
  max-height: 300px;
  overflow: auto;
}

.broadcast-item {
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f5f5f5;
}

.broadcast-item:last-child {
  border-bottom: none;
}

.broadcast-item:hover, 
.broadcast-item.highlight {
  background-color: #f0f7ff;
}

.broadcast-custom-item {
  padding: 10px 16px;
  background-color: #f8f8f8;
  border-top: 1px dashed #e0e0e0;
  color: #666;
  font-style: italic;
  text-align: center;
  font-size: 0.9rem;
}

.broadcast-custom-item span {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(74, 144, 226, 0.1);
}

.broadcast-menu-close {
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.broadcast-menu-close:hover {
  color: #128C7E;
  background: rgba(18, 140, 126, 0.1);
}

.broadcast-details {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  margin-top: 16px;
}

.broadcast-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #128C7E;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.broadcast-details-content {
  padding: 16px;
}

.broadcast-variables {
  margin-bottom: 16px;
}

.broadcast-variable-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.broadcast-preview {
  margin-bottom: 16px;
}

.broadcast-preview-content {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}

.broadcast-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.broadcast-send-btn {
  background: #128C7E;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.broadcast-send-btn:hover {
  background: #075E54;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(18, 140, 126, 0.2);
}

.broadcast-dismiss-btn {
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.broadcast-dismiss-btn:hover {
  color: #128C7E;
  background: rgba(18, 140, 126, 0.1);
}

.broadcast-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  color: #888;
}

.broadcast-loading .loader-small {
  width: 24px;
  height: 24px;
  margin-bottom: 8px;
}

.no-broadcast {
  color: #888;
  text-align: center;
  font-style: italic;
  padding: 20px 0;
}

.broadcast-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.broadcast-sent-success {
  background: #dff2d8;
  border: 1px solid #d6e9c6;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  color: #3c763d;
}

.broadcast-sent-success svg {
  color: #d6e9c6;
  margin-right: 10px;
}

.broadcast-select-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.broadcast-select {
  padding: 8px 32px 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  color: #37352f;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  transition: all 0.2s ease;
  min-width: 180px;
}

.broadcast-select:hover {
  border-color: #25D366;
}

.broadcast-select:focus {
  outline: none;
  border-color: #25D366;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
}

.broadcast-action-btn {
  background: #25D366;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.broadcast-action-btn:hover {
  background: #128C7E;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(37, 211, 102, 0.2);
}

.broadcast-action-btn:disabled,
.broadcast-action-btn.disabled-btn {
  background: #a0a0a0;
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
  box-shadow: none;
}

.loader-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

.matching-users-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.matching-users-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Styles pour le rapport de broadcast */
.broadcast-sent-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f9f1;
  border-radius: 8px;
  padding: 24px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.broadcast-report-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  width: 100%;
  text-align: center;
}

.broadcast-report-header p.broadcast-status-text {
  margin: 0 0 0 12px;
  color: #108a6e;
  font-weight: 500;
  display: block;
  padding: 8px;
}

.success-count {
  color: #25D366;
  font-weight: bold;
}

.failed-count {
  color: #e74c3c;
  font-weight: bold;
}

.total-count {
  color: #34495e;
  font-weight: bold;
}

.broadcast-report-container {
  width: 100%;
  margin: 16px 0;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.broadcast-report-summary {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
  gap: 12px;
}

.report-stat {
  display: flex;
  flex-direction: column;
  min-width: 120px;
}

.report-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.report-value {
  font-size: 14px;
  font-weight: 600;
  color: #34495e;
}

.broadcast-report-table {
  width: 100%;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

.broadcast-report-table table {
  width: 100%;
  border-collapse: collapse;
}

.broadcast-report-table th {
  background-color: #f9f9f9;
  padding: 10px;
  text-align: left;
  font-weight: 600;
  color: #555;
  position: sticky;
  top: 0;
  z-index: 1;
}

.broadcast-report-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.report-success {
  background-color: rgba(37, 211, 102, 0.05);
}

.report-success td {
  color: #128C7E;
}

.report-error, .report-fail {
  background-color: rgba(231, 76, 60, 0.05);
}

.report-error td, .report-fail td {
  color: #c0392b;
}

.message-id {
  font-family: monospace;
  font-size: 12px;
  background: rgba(37, 211, 102, 0.1);
  padding: 2px 4px;
  border-radius: 3px;
}

.error-details {
  font-size: 12px;
  color: #e74c3c;
  max-width: 200px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.broadcast-report-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
  width: 100%;
}

.broadcast-dismiss-btn {
  background-color: #fff;
  color: #128C7E;
  border: 1px solid #128C7E;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.broadcast-dismiss-btn:hover {
  background-color: #f0f9f1;
}

.broadcast-toggle-report-btn {
  background-color: #128C7E;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.broadcast-toggle-report-btn:hover {
  background-color: #0e6d5a;
}

/* Styles pour la section des réponses du serveur */
.broadcast-report-tabs {
  margin-bottom: 16px;
}

.tab-buttons {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
}

.tab-button {
  padding: 10px 16px;
  font-size: 14px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;
}

.tab-button.active {
  color: #128C7E;
  border-bottom-color: #128C7E;
  font-weight: 600;
}

.raw-responses-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 8px;
  display: block;
  width: 100%;
}

.raw-response-item {
  margin-bottom: 16px;
  background: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #eee;
  overflow: hidden;
}

.response-header {
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f3f3f3;
  border-bottom: 1px solid #eee;
}

.response-title {
  font-weight: 600;
  font-size: 14px;
  color: #444;
}

.response-status {
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
  background: #ffebee;
  color: #e53935;
}

.response-status.status-success {
  background: #e8f5e9;
  color: #388e3c;
}

.response-body {
  padding: 12px;
  margin: 0;
  background-color: #fafafa;
  font-family: Monaco, monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-x: auto;
  color: #333;
}

.no-responses {
  padding: 20px;
  text-align: center;
  color: #888;
  font-style: italic;
}

.playground-btn {
  background: #1EA355 !important;
  color: white !important;
  border: none !important;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.playground-btn:hover {
  background: #167F42 !important;
  transform: translateY(-1px);
}

.playground-btn svg {
  transition: transform 0.2s ease;
}

.playground-btn:hover svg {
  transform: scale(1.1);
}

.circle-icon.playground {
  background: linear-gradient(135deg, #1EA355 0%, #167c41 100%);
}

.playground-btn {
  background: #1EA355 !important;
  color: white !important;
  border: none !important;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.playground-btn:hover {
  background: #167F42 !important;
  transform: translateY(-1px);
}

.playground-btn svg {
  transition: transform 0.2s ease;
}

.playground-btn:hover svg {
  transform: scale(1.1);
}

.circle-icon.playground {
  background: linear-gradient(135deg, #1EA355 0%, #167c41 100%);
}
</style> 